export const en = {
  'authentification': {
    'bienvenu': 'Welcome',
    'commande_en_ligne': 'Online order',
    'compte_france_frais': 'Do you have an account?',
    'connectez_vous': 'Log in',
    'premiere_connexion': 'First time connecting?',
    'utiliser_email': 'Use your contact email address to register and access your account.',
    'activer_compte': 'Log in',
    'devenir_client': 'Become a France Frais customer',
    'contactez_nous': 'Contact Us',
    'tout_proche': 'France Frais, close to',
    'de_vous': 'you!',
    'error': {
      'erreur_rencontree': 'An error was encountered',
      'valider_email': 'You must validate that you are the owner of the email address by clicking on the email that was sent to you.',
      'email_envoye': 'Email sent, please check your inbox.',
      're_envoyer': 'Resend',
      'erreur': 'Error',
      'date_fin_validite_requise': 'End date is required',
      'champs_requis': 'Please fill in all required fields',
      'echec_demande_derogation': 'Failed to send derogation request',
      'erreur_inconnue': 'An unknown error occurred',
      'contacter_commercial': 'please contact your sales representative.',
      'email_correspond_plus': 'Your email no longer corresponds to a contact in our customer database. Please contact your sales representative.',
      'no_sandbox': 'You cannot connect to the sandbox.<br /><br />To access France Frais Connect please use the following link:<br /><br /><Link>https://ffconnect.france-frais.fr</Link>.',
      'switched': 'You have changed customer accounts in another tab. <br /><Link>Reload</Link>',
      'not_representant': 'Access denied. This interface is reserved for France Frais sales representatives.'
    }
  },
  'global': {
    'france_frais': 'France Frais',
    'erreur_chargement': 'Error while loading',
    'selectionner': 'Select',
    'selectionne': 'Selected',
    'produit': '{{count}} product',
    'produit_one': '{{count}} product',
    'produit_other': '{{count}} products',
    'produit_many': '{{count}} products',
    'produit_plural': '{{count}} products',
    'panier': '{{count}} cart',
    'panier_one': '{{count}} cart',
    'panier_other': '{{count}} carts',
    'panier_many': '{{count}} carts',
    'panier_plural': '{{count}} carts',
    'colis': '{{count}} package',
    'colis_one': '{{count}} package',
    'colis_other': '{{count}} packages',
    'colis_many': '{{count}} packages',
    'colis_plural': '{{count}} packages',
    'evenement': '{{count}} event',
    'evenement_one': '{{count}} event',
    'evenement_other': '{{count}} events',
    'evenement_many': '{{count}} events',
    'evenement_plural': '{{count}} events',
    'annuler': 'Cancel',
    'valider': 'Confirm',
    'envoyer': 'Send',
    'retour': 'Back',
    'voir': 'View',
    'remplacer': 'Replace',
    'consulter': 'Consult',
    'choisir': 'Choose',
    'creer': 'Create the list',
    'client': '{{count}} customer',
    'client_one': '{{count}} customer',
    'client_other': '{{count}} customers',
    'client_many': '{{count}} customers',
    'client_plural': '{{count}} customers',
    'a_valider': 'To validate',
    'promotion': 'Promotion',
    'produit_marche': 'Market product',
    'accueil': 'Home',
    'catalogue': 'Catalog',
    'cadencier': 'Reorder List',
    'ub_essentielles': 'Essential UBs',
    'mon_cadencier': 'Reorder List',
    'listes': 'Lists',
    'mes_listes': 'My Lists',
    'profil': 'Profile',
    'recherche': 'Search',
    'chargement': 'Loading',
    'revenir': 'Return',
    'connecter': 'Login',
    'accepter': 'I accept',
    'refuser': 'Refuse',
    'voir_mon_panier': 'View my cart',
    'choisir_livraison': 'Choose a delivery',
    'logo': 'logo',
    'raison_sociale': 'company name',
    'code': 'code',
    'attention': 'Warning',
    'modifier': 'Modify',
    'compris': 'Understood',
    'jai_compris': 'I understand',
    'alt_logo_france_frais': 'France Frais Logo',
    'jour': 'day',
    'mois': 'month',
    'mois_precedent': 'Previous month',
    'mois_suivant': 'Next month',
    'date': 'date',
    'quantite': 'quantity',
    'fiche_produit': 'Product sheet',
    'not_found': 'Not found',
    'error': 'Error',
    'error_field_required': 'This field is required.',
    'loading': 'Loading...',
    'clear_file': 'Clear file',
    'articles': 'Articles',
    'change_selection': 'Change selection',
    'searching': 'Searching...',
    'supprimer': 'Delete',
    'client_title': 'Client',
    'oui': 'Yes',
    'non': 'No',
    'fermer': 'Close',
    'yes': 'Yes',
    'no': 'No',
    'all': 'All',
    'reset_filters': 'Reset filters',
    'vous': 'You',
    'fichier_trop_volumineux': 'File "{{nom}}" exceeds the 5 MB limit',
    'reference': 'Reference',
    'telecharger': 'Download',
    'message': 'Message'
  },
  'header_band': {
    'temps_restant': 'Remember to order as soon as possible for your next delivery on <Text>{{date_de_livraison}}</Text>!',
    'contactez_nous': 'Contact us'
  },
  'paiement_cb_notice': {
    'titre': 'Card payment',
    'message': 'Only deliveries within the next {{jours}} days can be ordered',
    'fermer': 'Close banner'
  },
  'cadencier': {
    'retirer_des_produits': 'Remove products',
    'cta_panier': 'Go to cart',
    'mon_cadencier': 'My Reorder List',
    'quitter_edition': 'Exit edit mode',
    'chargement_cadencier': 'Loading your Reorder List',
    'effacer_recherche': 'Clear search',
    'aucun_article_filtre': 'No item matches the selected filters.',
    'aucune_ligne_tendance': 'No {{tendances}} line in this reorder list',
    'filtres_tendance': {
      'tout': 'All',
      'en-hausse': 'Rising',
      'gagne': 'Gained',
      'stable': 'Stable',
      'en-baisse': 'Falling',
      'perdu': 'Lost',
      'a-gagner': 'Not ordered',
    },
    'suggestion': {
      'texte': 'Suggestion: {{count}} {{unite}}',
      'tooltip': 'Based on your purchasing habits',
      'remplir_avec_suggestions': 'Fill my cart automatically',
      'articles_ajoutes_au_panier': '{{count}} item successfully added to cart',
      'articles_ajoutes_au_panier_one': '{{count}} item successfully added to cart',
      'articles_ajoutes_au_panier_other': '{{count}} items successfully added to cart',
      'articles_ajoutes_au_panier_many': '{{count}} items successfully added to cart',
      'article_changement_quantite': 'The item quantity has been successfully modified',
      'remplissez_votre_panier': 'Your cart in 1 click!',
      'ajoutez_en_un_clic': 'Custom: find your usual products and quantities with one click.',
      'quantite_suggeree_presente': 'Quantity automatically added based on your habits - modify it if needed.',
      'savoir_plus': 'Learn more',
      'savoir_plus_tooltip': 'Products in your Reorder List with a quantity suggestion based on your habits will be added to the cart.',
      'action_annulee': '{{count}} item canceled',
      'action_annulee_one': '{{count}} item canceled',
      'action_annulee_other': '{{count}} items canceled',
      'action_annulee_many': '{{count}} items canceled',
      'action_annulee_plural': '{{count}} items canceled',
      'annulation_echouee': 'Cancellation failed',
      'ligne_introuvable': 'Cart line not found for item {{code_article}}',
      'pas_suggestions_disponibles': 'No quantity suggestion available within your Reorder List.',
    },
    'tri': {
      'tri': 'Sort: ',
      'alphabetique': 'Alphabetical',
      'frequence': 'Purchase frequency'
    },
    'filtre': {
      'promotions': 'Promotions',
      'labels': 'Labels',
      'fromage': 'Cheese',
    },
    'modale_retirer': {
      'titre': 'Remove from Reorder List',
      'selectionner_raison': 'Select the reason:',
      'raison_plus_de_commande': 'I no longer order this product',
      'raison_pas_interesse': 'I am not interested in this product',
      'raison_autre_similaire': 'I have another similar product',
      'raison_deja_ailleurs': 'I already order this product elsewhere',
      'valider_et_retirer': 'Validate and Remove from Reorder List',
      'annuler': 'Cancel'
    }
  },
  'temperature_livraison': {
    'la_livraison_du': 'The delivery of',
    'surgeles_uniquement': 'Frozen only',
    'non_surgeles_uniquement': 'Non-frozen only',
    'livraison_surgelee': 'Frozen delivery',
    'pas_de_surgele': 'No frozen',
    'livraison_non_surgelee': 'Non-frozen delivery',
    'livraison_surgeles_uniquement': 'Frozen delivery only',
    'livraison_non_surgeles_uniquement': 'Non-frozen delivery only',
    'est_livraison_surgeles_uniquement': 'is a frozen-only delivery.',
    'est_livraison_non_surgeles_uniquement': 'is a non-frozen-only delivery.',
    'warning_temperature_ignoree': 'Warning: displayed products may not be available for this delivery temperature'
  },
  'toast': {
    'ajoute_panier_date': 'Product <strong>added to cart for {{date, datetime}}</strong>',
    'ajoute_panier_marketplace': 'Product added to <strong>{{marketplace}}</strong> cart',
    'modifie_panier_date': 'Product quantity modified <strong>in your cart for {{date, datetime}}</strong>',
    'supprime_panier': 'Product removed from cart',
    'supprime_cadencier': 'Product #{{code_article}} has been removed from the Reorder List',
    'supprime_cadencier_simulation': "Product #{{code_article}} wasn't actually removed from the Reorder List",
    'supprime_cadencier_safelive': 'Product #{{code_article}} has actually been removed from the Reorder List.<br />For it to be taken into account, add it to the Reorder List right away',
    'supprime_liste': 'Product #{{code_article}} has been removed from the list',
    'warning_minimum': 'The minimum quantity is {{minimum}}',
    'warning_arrondis': 'The quantity has been adjusted to the nearest higher multiple (multiple:{{multiple}})',
    'ajout_preco': 'The product has been added to the cart for {{date, datetime}}',
    'unite_switchee': 'The quantity has changed to <strong>{{quantite}} packages</strong>',
    'produit_introuvable_supprime': 'The product cannot be found and cannot be deleted.',
    'ajout_nouvelle_liste': 'The list {{newListName}} has been created',
    'ajout_liste': 'The item has been added to the list',
    'ajout_cadencier': 'The product has been added to the Reorder List',
    'ajout_cadencier_simulation': "The product hasn't actually been added to the Reorder List",
    'ajout_cadencier_safelive': 'The product has actually been added to the Reorder List.<br />For it not to be taken into account, remove it from the Reorder List right away',
    'panier_deplace': 'Cart moved to <strong>{{date, datetime}}</strong>',
    'panier_vidé': 'The cart for {{date}} has been emptied',
    'produit_differe': 'Product <strong>moved to cart for {{date}}.</strong>',
    'produit_differe_cta': "Don't forget to validate it as soon as possible.",
    'produit_remplace': 'Product replaced by {{libelle}}',
    'voir_panier': 'View cart',
    'voir_liste': 'View list',
    'produit_precommande': 'Warning pre-order product',
    'quantite_ajustee': 'The quantity has been adjusted to {{quantite}} {{unite}}',
    'donnees_rafraichies': 'Customer data has been successfully updated.',
    'panier_valide_simulation': "Your cart has been checked but hasn't actually been converted to an order in Tolede.",
    'panier_valide_safelive': 'Your cart has actually been converted to an order in Tolede.<br />To prevent it from being prepared, you must cancel it right away.',
    'prolonge_session': 'Your session has been successfully extended.',
    'prolongement_session_impossible': 'Unable to extend your session.',
    'clients_rafraichis': 'The customer list has been successfully refreshed.',
    'cgv_reinitialisees': 'Terms and Conditions acceptances have been reset for all customers.',
    'invitation_envoyee': 'The invitation has been successfully sent to {{email}}.',
    'relance_envoyee': 'The reminder has been successfully sent to {{email}}.',
    'article_deja_present': 'This item is already in your list.'
  },
  'panier': {
    'panier': 'Cart',
    'panier_pdf': 'Cart - PDF order',
    'pdf': 'PDF',
    'matching_filtre_tout': 'All',
    'matching_filtre_ok': 'Ok: {{nombre}}',
    'matching_filtre_alerte': 'To check: {{nombre}}',
    'matching_filtre_bloquant': 'To check first: {{nombre}}',
    'matching_details': 'Details',
    'matching_remplace': 'Replaced',
    'matching_correspondance_initiale': 'Initial match',
    'matching_phrase': {
      'code_exact_libelle_exact': {
        'ok': 'Line OK: item recognised (exact code and label) and exact price.',
        'alerte': 'Line to check due to a slight price difference ({{ecart}}). The item was correctly recognised (exact code and label).',
        'ko': 'Line to check due to the price difference ({{ecart}}). The item was correctly recognised (exact code and label).',
        'vide': 'Line to check as the price is missing and could not be compared. The item was correctly recognised (exact code and label).'
      },
      'code_exact_libelle_proche': {
        'ok': 'Line OK: item recognised (exact code but label not entirely exact) and exact price.',
        'alerte': 'Line to check due to a slight price difference ({{ecart}}). The item was correctly recognised (exact code but label not entirely exact).',
        'ko': 'Line to check due to the price difference ({{ecart}}). The item was correctly recognised (exact code but label not entirely exact).',
        'vide': 'Line to check as the price is missing and could not be compared. The item was correctly recognised (exact code but label not entirely exact).'
      },
      'code_exact_libelle_non_reconnu': {
        'ok': 'Line to check: the code is exact but the label is not recognised, risk of error on the item. The price is exact.',
        'alerte': 'Line to check: the code is exact but the label is not recognised, with a slight price difference ({{ecart}}).',
        'ko': 'Line to check: the code is exact but the label is not recognised, and the price differs by {{ecart}}.',
        'vide': 'Line to check: the code is exact but the label is not recognised, and the price is missing.'
      },
      'code_different_libelle_exact': {
        'ok': 'Line OK: item recognised (exact label but different code) and exact price.',
        'alerte': 'Line to check due to a slight price difference ({{ecart}}). The item was correctly recognised (exact label but different code).',
        'ko': 'Line to check due to the price difference ({{ecart}}). The item was correctly recognised (exact label but different code).',
        'vide': 'Line to check as the price is missing and could not be compared. The item was correctly recognised (exact label but different code).'
      },
      'code_different_libelle_proche': {
        'ok': 'Line to check as the identification is uncertain (different code and label not entirely exact). The price is exact.',
        'alerte': 'Line to check as the identification is uncertain (different code and label not entirely exact), with a slight price difference ({{ecart}}).',
        'ko': 'Line to check as the identification is uncertain (different code and label not entirely exact), and the price differs by {{ecart}}.',
        'vide': 'Line to check as the identification is uncertain (different code and label not entirely exact), and the price is missing.'
      },
      'code_different_libelle_non_reconnu': {
        'ok': 'Line to check: item not recognised (neither the code nor the label match), even though the price is exact.',
        'alerte': 'Line to check: item not recognised (neither the code nor the label match), with a slight price difference ({{ecart}}).',
        'ko': 'Line to check: item not recognised (neither the code nor the label match) and price difference ({{ecart}}).',
        'vide': 'Line to check: item not recognised (neither the code nor the label match) and missing price.'
      },
      'code_absent_libelle_exact': {
        'ok': 'Line OK: item recognised (exact label, no code on the purchase order) and exact price.',
        'alerte': 'Line to check due to a slight price difference ({{ecart}}). The item was correctly recognised (exact label, no code on the purchase order).',
        'ko': 'Line to check due to the price difference ({{ecart}}). The item was correctly recognised (exact label, no code on the purchase order).',
        'vide': 'Line to check as the price is missing and could not be compared. The item was correctly recognised (exact label, no code on the purchase order).'
      },
      'code_absent_libelle_proche': {
        'ok': 'Line to check as the identification is uncertain (no code on the purchase order and label not entirely exact). The price is exact.',
        'alerte': 'Line to check as the identification is uncertain (no code on the purchase order and label not entirely exact), with a slight price difference ({{ecart}}).',
        'ko': 'Line to check as the identification is uncertain (no code on the purchase order and label not entirely exact), and the price differs by {{ecart}}.',
        'vide': 'Line to check as the identification is uncertain (no code on the purchase order and label not entirely exact), and the price is missing.'
      },
      'code_absent_libelle_non_reconnu': {
        'ok': 'Line to check: item not recognised (no code on the purchase order and label not recognised), even though the price is exact.',
        'alerte': 'Line to check: item not recognised (no code on the purchase order and label not recognised), with a slight price difference ({{ecart}}).',
        'ko': 'Line to check: item not recognised (no code on the purchase order and label not recognised) and price difference ({{ecart}}).',
        'vide': 'Line to check: item not recognised (no code on the purchase order and label not recognised) and missing price.'
      }
    },
    'matching_aucune_correspondance': 'No match',
    'matching_article_indisponible': 'Item identified but not added to the cart',
    'matching_ligne_supprimee': 'PDF line removed from the cart',
    'matching_aucune_ligne_filtre': 'No line matches this filter',
    'matching_resultat_ok': 'OK',
    'matching_resultat_ko': 'KO',
    'finaliser_commande': 'Review and finalize',
    'panier_vide': 'Your cart is empty',
    'ajouter_au_panier': 'Add to cart',
    'deja_au_panier': 'Already in cart',
    'panier_vide_cta': 'Order now!',
    'panier_vide_cta_mobile': 'You can order now',
    'panier_vide_cta_top': "Don't forget to validate your open carts as soon as possible!",
    'paniers_ouverts': 'open carts',
    'paniers_ouverts_one': 'Open cart',
    'paniers_ouverts_other': 'Open carts',
    'livraison_48h_72h': 'Delivery by MATFER within 48 to 72h',
    'livraison_48h_72h_court': 'Delivery within 48h to 72h',
    'paniers': 'Cart',
    'paniers_one': 'Cart',
    'paniers_other': 'Carts',
    'paniers_plural': 'Carts',
    'paniers_many': 'Carts',
    'paniers_actifs': 'Active cart',
    'paniers_actifs_one': 'Active cart',
    'paniers_actifs_other': 'Active carts',
    'paniers_actifs_plural': 'Active carts',
    'paniers_actifs_many': 'Active carts',
    'paniers_label': 'carts',
    'livraison_selectionnee': 'Selected delivery',
    'depuis_cadencier': 'From my Reorder List',
    'depuis_catalogue': 'From the catalog',
    'depuis_listes': 'From my lists',
    'remplacement_de': 'Replacement of {{produit}}',
    'pour_la_livraison_du': 'For delivery on <strong>{{date, datetime}}</strong>',
    'pour_la_livraison_du_mobile': 'Delivery on <strong>{{date, datetime}}</strong>',
    'nous_validons': 'We are validating your cart',
    'menu_tooltip': 'Show cart for {{date}}',
    'changer_date': 'Change date',
    'commander_pour_une_autre_date': 'Order for another date',
    'panier_a_valider': 'My carts to validate',
    'x_panier_a_valider': '{{count}} cart to validate',
    'x_panier_a_valider_one': '{{count}} cart to validate',
    'x_panier_a_valider_other': '{{count}} carts to validate',
    'x_panier_a_valider_plural': '{{count}} carts to validate',
    'liste_livraisons_prompt_mobile': 'Order for another date',
    'supprimer_panier_confirm': 'Are you sure you want to empty the cart?',
    'supprimer_panier_action': 'Empty cart',
    'supprimer_panier_action_mobile': 'Empty',
    'panier_en_cours': 'Current cart',
    'commande_existant': 'Existing order for this delivery day',
    'listes': '{{count}} list',
    'listes_one': '{{count}} list',
    'listes_other': '{{count}} lists',
    'listes_plural': '{{count}} lists',
    'confirmer_adresse_livraison': {
      'titre': 'Confirm your delivery address',
      'bouton_confirmer': 'I confirm',
      'bouton_changer_adresse': 'Change address'
    },
    'error': {
      'hors_delai': {
        'tolerance': 'We are forwarding this order to our services even though it is late (order cutoff time : {{heure_a_atteindre}}). Thank you for your attention to future orders. ',
        'surcout': 'This order is late. An extra charge of {{surcout_a_valider}} euros is applied (order cutoff time : {{heure_a_atteindre}}).',
        'bloquant': 'The order time exceeds the maximum acceptable delay (order cutoff time : {{heure_a_atteindre}}).'
      },
      'franco': {
        'tolerance': {
          'montant_a_atteindre': 'We are forwarding this order to our services even though it does not meet the minimum amount (minimum order amount : {{montant_a_atteindre}} euros). Thank you for your attention to future orders.',
          'poids_a_atteindre': 'We are forwarding this order to our services even though it does not meet the minimum weight (minimum order weight : {{poids_a_atteindre}} kg). Thank you for your attention to future orders.',
          'montant_a_atteindre_et_poids_a_atteindre': 'We are forwarding this order to our services even though it does not meet the minimum amount and weight (minimum order : {{montant_a_atteindre}} euros, {{poids_a_atteindre}} kg). Thank you for your attention to future orders.'
        },
        'surcout': {
          'montant_a_atteindre': 'This order does not meet the minimum order amount (minimum order amount : {{montant_a_atteindre}} euros). An extra charge of {{surcout_a_valider}} euros is applied.',
          'poids_a_atteindre': 'This order does not meet the minimum order weight (minimum order weight : {{poids_a_atteindre}} kg). An extra charge of {{surcout_a_valider}} euros is applied.',
          'montant_a_atteindre_et_poids_a_atteindre': 'This order does not meet the minimum order amount and weight  (minimum order : {{montant_a_atteindre}} euros, {{poids_a_atteindre}} kg). An extra charge of {{surcout_a_valider}} euros is applied.'
        },
        'bloquant': {
          'montant_a_atteindre': 'This order does not meet the minimum order amount (minimum order amount : {{montant_a_atteindre}} euros).',
          'poids_a_atteindre': 'This order does not meet the minimum order weight (minimum order weight : {{poids_a_atteindre}} kg).',
          'montant_a_atteindre_et_poids_a_atteindre': 'This order does not meet the minimum order amount and weight (minimum order : {{montant_a_atteindre}} euros, {{poids_a_atteindre}} kg).'
        }
      }
    },
    'vide': {
      'votre_panier_est_vide': 'Your cart is empty.',
      'merci': 'Thank you',
      'pour_votre_commande': 'for your order!',
      'vous_allez_recevoir_email': 'You will receive a confirmation email shortly.',
      'consulter_detail_commande': 'You can view your order details at any time in the "My Orders" section.',
      'pour_toute_question': 'For any questions about your order, please contact your advisor.',
      'vous_avez_x_panier': 'You have {{count}} cart to validate.',
      'vous_avez_x_panier_one': 'You have {{count}} cart to validate.',
      'vous_avez_x_panier_other': 'You have {{count}} carts to validate.',
      'vous_avez_x_panier_plural': 'You have {{count}} carts to validate.',
      'validez_pour_reserver': 'Validate your current carts to reserve your stock.',
      'n_oubliez_pas_de_valider_restant': "Don't forget to validate<br/>your remaining cart",
      'n_oubliez_pas_de_valider_restant_one': "Don't forget to validate<br/>your remaining cart",
      'n_oubliez_pas_de_valider_restant_other': "Don't forget to validate<br/>your remaining carts",
      'n_oubliez_pas_de_valider_restant_many': "Don't forget to validate<br/>your remaining carts",
      'n_oubliez_pas_de_valider_restant_plural': "Don't forget to validate<br/>your remaining carts",
      'prenez_de_lavance': 'Get ahead!',
      'preparez_prochaine_livraison': 'Prepare your next delivery now',
      'alt_carton_vide': 'Empty order box'
    },
    'recap': {
      'recapitulatif': 'Summary',
      'valider_le_panier': 'Validate cart',
      'valider_mon_panier': 'Validate my cart',
      'valider_et_payer': 'Validate and pay',
      'total_ht': 'Total excluding tax',
      'surcout_ht': 'Extra charge excluding tax',
      'total_tva': 'Total VAT',
      'total_ttc': 'Total including tax',
      'tooltip_total_ht': 'Estimated amount based on ordered quantities and will be adjusted upon delivery',
      'statut_tolede': 'Tolede status',
      'commande_impossible': 'Ordering is not possible',
      'motif_blocage_non_precise': 'Reason not specified',
      'accepter_conditions': 'I accept <Link>the general terms of sale</Link>',
      'mode_de_rendu': {
        'enlevement': 'Warehouse pickup',
        'livraison': 'Delivery',
        'presta_direct': 'Delivery'
      },
      'modale_adresse': {
        'titre_enlevement': 'Pick up your order at your warehouse',
        'titre_livraison': 'Delivery'
      },
      'reference_commande': 'Order reference',
      'reference_commande_needed': 'Order reference (required)*',
      'commentaire_commande': 'Comment',
      'commentaire_commande_placeholder': 'Add a comment to your order...',
      'marketplace_livraison_titre': 'Service + delivery',
      'marketplace_livraison_delai': 'Delivered by MATFER within 48h to 72h',
      'option_de_paiement': 'Payment option',
      'paiement_par_carte_bancaire': 'Credit card payment',
      'tooltip_paiement': 'If you wish to use other payment methods, please contact your sales representative',
    },
    'validez': {
      'plus_de_2_jours': 'Validate your cart to block quantities.',
      'moins_de_2_jours': 'Only <strong>{{date}}</strong> left to be delivered on the chosen date.'
    },
    'paiement': {
      'traitement_en_cours': 'Processing payment...',
      'ne_pas_fermer': 'Please do not close this page.',
      'erreur_initiation': 'Could not initiate payment. Please try again.',
      'retour_panier': 'Back to cart',
      'transaction_echouee': 'The transaction could not complete',
      'redirection_panier': 'You will be redirected to the cart',
    },
    'quantites_inhabituelles': {
      'titre': 'Unusual quantities',
      'message': 'The quantities of these products are unusual:',
      'message_one': 'The quantity of this product is unusual:',
      'message_other': 'The quantities of these products are unusual:',
      'message_plural': 'The quantities of these products are unusual:',
      'message_suite': 'Do you want to validate your order or modify these quantities?',
      'modifier': 'Modify',
      'valider': 'Validate'
    },
    'paniers_label_one': 'cart',
    'paniers_label_other': 'carts',
    'paniers_label_plural': 'carts',
    'paniers_label_many': 'carts'
  },
  'bouton_achat': {
    'buy': 'Add to cart',
    'buy_court': 'Add',
    'ajouter_au_devis': 'Add to quote',
    'produit_ajoute_au_devis': 'Product added',
    'preco': 'Pre-order'
  },
  'ligne_produit': {
    'promotion_non_applicable':
      'This promotion does not apply to the selected delivery date',
    'soit_prix': 'or {{prix}}€',
    'retirer_le_produit': 'Remove',
    'poids_variable': 'Variable weight',
    'poids_variable_label': 'The product will be billed at actual weight',
    'tva_percent': 'VAT {{tauxTVA}}%',
    'HT': 'excl. tax',
    'TTC': 'incl. tax',
    'encart_dlc': 'Estimated best before date: <strong>{{date}}</strong>',
    'encart_dlc_tooltip': 'Same day best before date for same day preparation',
    'afficher_dlc_stock': 'Show expiry date and stock',
    'indisponible': {
      'rupture_partielle': 'Only <strong>{{quantite_max}}</strong> is available <i>(requested quantity: {{quantite_demande}})</i>',
      'rupture_partielle_one': 'Only <strong>{{quantite_max}}</strong> is available <i>(requested quantity: {{quantite_demande}})</i>',
      'rupture_partielle_other': 'Only <strong>{{quantite_max}}</strong> are available <i>(requested quantity: {{quantite_demande}})</i>',
      'rupture_partielle_plural': 'Only <strong>{{quantite_max}}</strong> are available <i>(requested quantity: {{quantite_demande}})</i>',
      'rupture': 'Out of stock ({{quantite}} {{unite}} in cart)',
      'delai_de_prepa_long': 'This item cannot be prepared in time for this delivery.',
      'delai_de_prepa_long_avec_date': 'This item cannot be prepared in time for this delivery. Next available date: <strong>{{date}}</strong>.',
      'generique': 'An issue prevents ordering this item.',
      'date_dispo': 'Available from <strong>{{date}}</strong>',
      'remplacer': 'Replace',
      'differer': 'Defer',
      'differer_livraison': 'Defer delivery',
      'ajuster_quantite': 'Adjust quantity to {{quantite}} {{unite}}',
      'ajuster_quantite_court': 'Adjust quantity',
      'tooltip_ajuster_quantite': 'Adjust to {{quantite}} {{unite}} in cart',
      'tooltip_rupture_totale': 'Remove from cart',
      'entete': '<strong>{{count}} product</strong> is unavailable for <strong>{{dateDeLivraison}}</strong>',
      'entete_one': '<strong>{{count}} product</strong> is unavailable for <strong>{{dateDeLivraison}}</strong>',
      'entete_other': '<strong>{{count}} products</strong> are unavailable for <strong>{{dateDeLivraison}}</strong>',
      'entete_plural': '<strong>{{count}} products</strong> are unavailable for <strong>{{dateDeLivraison}}</strong>',
      'entete_no_date': '<strong>{{count}} product</strong> is unavailable',
      'entete_no_date_one': '<strong>{{count}} product</strong> is unavailable',
      'entete_no_date_other': '<strong>{{count}} products</strong> are unavailable',
      'entete_no_date_plural': '<strong>{{count}} products</strong> are unavailable',
      'produit_indisponible': 'Product unavailable for {{dateDeLivraison}}',
      'produit_indisponible_short': 'Product unavailable',
      'article_indisponible': 'Item unavailable',
    }
  },
  'disponibilite': {
    'precommande': 'Pre-order',
    'a_partir': 'From {{date}}'
  },
  'modale_livraison': {
    'header': {
      'selection_periode': 'Select a delivery period',
      'preco': 'Choose your delivery date',
      'changement_panier': 'Change delivery date',
      'default': 'Change delivery date',
      'ouvrir': 'Open a cart for another date'
    },
    'preco': {
      'title': 'Pre-order product',
      'info': 'This product will only be available from the dates below.',
      'date': 'Available dates after {{dateDebut, datetime}}:'
    },
    'legende': {
      'jour_selectionne': 'Selected delivery day',
      'panier_en_cours': 'Current cart',
      'panier_valide': 'Validated cart'
    },
    'changer_date': 'Select this date',
    'valider_date': 'Validate delivery date',
    'afficher_plus': 'Show more dates',
    'nous-requetons-les-disponibilites-de-larticle': 'We are requesting product availability'
  },
  'erreur404': {
    'alt_img_carton': 'empty box with "Oops!" written at the bottom',
    'c_est_bien_vide_ici': "Hmm... It's quite empty here",
    'pas_de_panique': "Don't panic, this way to fill it:",
    'voir_cadencier': 'View my Reorder List',
    'voir_catalogue': 'View catalog',
    'retour_accueil': 'Return to home'
  },
  'backoffice_erreur404': {
    'alt_img_carton': 'empty box with "Oops!" written at the bottom',
    'page_introuvable': 'Page not found',
    'verifier_url': 'This page does not exist or no longer exists. Check the URL or return to the FFcommerce home.',
    'retour_backoffice': 'Return to home'
  },
  'error': {
    'introuvable_en_db': 'The item cannot be found in the database.',
    'cgv_requise': 'Accepting the general terms of sale is required.',
    'echec_call_api': 'An error has occurred.',
    'item_catalogue_introuvable': 'Article not found in catalog.',
    'quantite_invalide': 'The quantity is not a customer order multiple.',
    'code_adresse_de_livraison_inconnu': "This delivery address doesn't exist for this customer.",
    'livraison_introuvable': 'No delivery for this date and this customer.',
    'quantite_en_colis_indisponible': 'The package quantity is not available for this item.',
    'unite_deja_selectionnee': 'The requested unit is already the one selected.',
    'prix_a_zero': 'The catalog price for this item is not specified.',
    'label_asset_introuvable': 'Image loading failed.',
    'probleme_bloquant_sur_commande': 'Order registration failed, check your cart.',
    'article_deja_present_dans_le_panier': 'The item is already in the cart for the target delivery.',
    'article_deja_present_dans_le_devis': 'The item is already in the quote.',
    'changement_mode_de_rendu_impossible': 'Unable to change rendering mode for this delivery.',
    'doublon_liste': 'The product is already in this list.',
    'quantite_max_depassee': 'Insufficient stock quantity for product <strong>{{libelle}}</strong><br />Maximum orderable: <strong>{{max}} {{unite}}</strong>.',
    'article_inconnu': 'Article information not found.',
    'medias_non_touves': 'Problem retrieving media associated with the article.',
    'panier_introuvable_en_db': 'This cart cannot be found,<br /><strong><Reload>please refresh your page.</Reload></strong>.',
    'ligne_de_panier_introuvable_en_db': 'This cart line cannot be found,<br /><strong><Reload>please refresh your page.</Reload></strong>.',
    'panier_tolede_mode_desactive': 'Converting a cart to a Tolede order is not authorized.',
    'cadencier_tolede_mode_desactive': 'Actions on the Reorder List are not authorized.',
    'colis_ajuste': 'The quantity has been adjusted to the nearest package.',
    'controle_panier': 'An error occurred while validating the cart.<br />Please try again later.',
    'commande_panier': 'The cart could not be validated, please try again later.<br /><Contact>If the problem persists, please contact us</Contact>.',
    'controle_dispo': 'We could not verify the availability of the item.<br />Please try again later.',
    'client_bloque': 'You cannot place orders from this account, <Contact>please contact us.</Contact>.',
    'generique': 'An error in the order prevents its processing.',
    'quantite_trop_importante': 'Quantity too large for one or more products.',
    'rupture': 'Product {{libelle}} is out of stock.',
    'erreur_date_livraison': 'The delivery date is earlier than the current date. Modify your order date.',
    'delai_livraison_trop_long_cb': 'Card payment is only available for deliveries within the next 6 days.',
    'panier_sans_ligne': 'The cart does not contain any product.',
    'commande_deja_validee': 'This order has already been validated.',
    'deja_au_cadencier': 'The item is already in the Reorder List.',
    'erreur_cadencier': 'The reorder list modification was rejected.',
    "la valeur d'une clé dupliquée rompt la contrainte unique « liste_selection_pkey »": '$t(error.doublon_liste)',
    'duplicate key value violates unique constraint "liste_selection_pkey"': '$t(error.doublon_liste)',
    'dispo': {
      'erreur_generique': 'An error related to item availability has occurred. Check your cart.',
      'erreur_quantite_insuffisante': 'Insufficient stock for this item. Check your cart.'
    },
    'date_differer_manquante': 'Error: The next delivery date for this item has not been communicated',
    'rupture_article': 'The desired quantity for your item is unavailable.',
    'no_client': 'No customer for this commercial company.',
    'no_tournee': 'No delivery route scheduled for this commercial company.',
    'article_introuvable': 'Article not found in the database.',
    'reference': 'Order Reference is required',
    'article_obsolete': 'Obsolete article',
    'non_commercialise': 'Non-commercialized article',
    'non_autorise': 'Unauthorized article',
    'non_web': 'Non-web article',
    'erreur_temperature_tournee': 'Delivery route temperature error',
    'erreur_multiple_de_commande': 'Order multiple error',
    'heure_depassee': 'Time exceeded',
    'adresse_inconnue': 'Unknown address',
    'client_inconnu': 'Unknown customer',
    'erreur_code_tournee': 'Delivery route code error',
    'erreur_mode_de_rendu': 'Delivery mode error',
    'erreur_nb_lignes': 'Number of lines error',
    'delai_de_prepa_long': 'This item cannot be prepared in time for this delivery.',
    'prix_plancher': 'Price below floor price.',
    'tooltip_generique_details': '{{message}} ({{code}})',
    'cadencier_desactive': 'Adding to the Reorder List is temporarily disabled.',
    'unknown': 'An error occurred during search. Please try again in a moment.',
    'index.building': 'The search index is being prepared. Please try again in a moment.',
    'index.building_started': 'We are preparing the search index. Please try again in a few minutes.',
    'index.build_failed': 'Unable to prepare the search index. Please contact support.',
    'panier_pas_en_attente_paiement': 'The cart is not awaiting payment.',
    'paiement_non_confirme': 'Payment was not confirmed. Please try again.',
    'catalogue_grand_compte_unauthorized': 'Access denied. You do not have access to the full catalog.'
  },
  'unite': {
    'B': 'bottle',
    'B_one': 'bottle',
    'B_other': 'bottles',
    'B_many': '$t(unite.B_other)',
    'B_plural': '$t(unite.B_other)',
    'BA': 'tray',
    'BA_one': 'tray',
    'BA_other': 'trays',
    'BA_many': '$t(unite.BA_other)',
    'BA_plural': '$t(unite.BA_other)',
    'BB': 'jar',
    'BB_one': 'jar',
    'BB_other': 'jars',
    'BB_many': '$t(unite.BB_other)',
    'BB_plural': '$t(unite.BB_other)',
    'BC': 'tub',
    'BC_one': 'tub',
    'BC_other': 'tubs',
    'BC_many': '$t(unite.BC_other)',
    'BC_plural': '$t(unite.BC_other)',
    'BI': 'can',
    'BI_one': 'can',
    'BI_other': 'cans',
    'BI_many': '$t(unite.BI_other)',
    'BI_plural': '$t(unite.BI_other)',
    'BO': 'basket',
    'BO_one': 'basket',
    'BO_other': 'baskets',
    'BO_many': '$t(unite.BO_other)',
    'BO_plural': '$t(unite.BO_other)',
    'BT': 'can',
    'BT_one': 'can',
    'BT_other': 'cans',
    'BT_many': '$t(unite.BT_other)',
    'BT_plural': '$t(unite.BT_other)',
    'BX': 'box',
    'BX_one': 'box',
    'BX_other': 'boxes',
    'BX_many': '$t(unite.BX_other)',
    'BX_plural': '$t(unite.BX_other)',
    'C1': 'C1',
    'C1_one': 'C1',
    'C1_other': 'C1',
    'C1_many': '$t(unite.C1_other)',
    'C1_plural': '$t(unite.C1_other)',
    'C2': 'C2',
    'C2_one': 'C2',
    'C2_other': 'C2',
    'C2_many': '$t(unite.C2_other)',
    'C2_plural': '$t(unite.C2_other)',
    'CA': 'carton',
    'CA_one': 'carton',
    'CA_other': 'cartons',
    'CA_many': '$t(unite.CA_other)',
    'CA_plural': '$t(unite.CA_other)',
    'CI': 'small crate',
    'CI_one': 'small crate',
    'CI_other': 'small crates',
    'CI_many': '$t(unite.CI_other)',
    'CI_plural': '$t(unite.CI_other)',
    'CN': 'CN',
    'CN_one': 'CN',
    'CN_other': 'CN',
    'CN_many': '$t(unite.CN_other)',
    'CN_plural': '$t(unite.CN_other)',
    'CO': 'package',
    'CO_one': 'package',
    'CO_other': 'packages',
    'CO_many': '$t(unite.CO_other)',
    'CO_plural': '$t(unite.CO_other)',
    'CT': 'Hundred',
    'CT_one': 'Hundred',
    'CT_other': 'Hundred',
    'CT_many': '$t(unite.CT_other)',
    'CT_plural': '$t(unite.CT_other)',
    'FU': 'keg',
    'FU_one': 'keg',
    'FU_other': 'kegs',
    'FU_many': '$t(unite.FU_other)',
    'FU_plural': '$t(unite.FU_other)',
    'KG': 'kg',
    'KG_one': 'kg',
    'KG_other': 'kg',
    'KG_many': '$t(unite.KG_other)',
    'KG_plural': '$t(unite.KG_other)',
    'L': 'liter',
    'L_one': 'liter',
    'L_other': 'liters',
    'L_many': '$t(unite.L_other)',
    'L_plural': '$t(unite.L_other)',
    'LO': 'lot',
    'LO_one': 'lot',
    'LO_other': 'lots',
    'LO_many': '$t(unite.LO_other)',
    'LO_plural': '$t(unite.LO_other)',
    'MI': 'Thousand',
    'MI_one': 'Thousand',
    'MI_other': 'Thousands',
    'MI_many': '$t(unite.MI_other)',
    'MI_plural': '$t(unite.MI_other)',
    'PI': 'piece',
    'PI_one': 'piece',
    'PI_other': 'pieces',
    'PI_many': '$t(unite.PI_other)',
    'PI_plural': '$t(unite.PI_other)',
    'PO': 'portion',
    'PO_one': 'portion',
    'PO_other': 'portions',
    'PO_many': '$t(unite.PO_other)',
    'PO_plural': '$t(unite.PO_other)',
    'PT': 'tray',
    'PT_one': 'tray',
    'PT_other': 'trays',
    'PT_many': '$t(unite.PT_other)',
    'PT_plural': '$t(unite.PT_other)',
    'SA': 'bag',
    'SA_one': 'bag',
    'SA_other': 'bags',
    'SA_many': '$t(unite.SA_other)',
    'SA_plural': '$t(unite.SA_other)',
    'SO': 'bucket',
    'SO_one': 'bucket',
    'SO_other': 'buckets',
    'SO_many': '$t(unite.SO_other)',
    'SO_plural': '$t(unite.SO_other)',
    'SC': 'bag',
    'SC_one': 'bag',
    'SC_other': 'bags',
    'SC_many': '$t(unite.SA_other)',
    'SC_plural': '$t(unite.SA_other)',
    'colis': 'package',
    'colis_one': 'package',
    'colis_other': 'packages',
    'colis_many': '$t(unite.colis_other)',
    'colis_plural': '$t(unite.colis_other)'
  },
  'month': {
    '1': 'January',
    '2': 'February',
    '3': 'March',
    '4': 'April',
    '5': 'May',
    '6': 'June',
    '7': 'July',
    '8': 'August',
    '9': 'September',
    '10': 'October',
    '11': 'November',
    '12': 'December'
  },
  'countries': {
    'FR': 'France',
    'ES': 'Spain',
    'IT': 'Italy',
    'DE': 'Germany',
    'GB': 'United Kingdom',
    'US': 'United States',
    'CN': 'China',
    'IN': 'India',
    'JP': 'Japan',
    'BR': 'Brazil',
    'RU': 'Russia',
    'CA': 'Canada',
    'AU': 'Australia',
    'KR': 'South Korea',
    'MX': 'Mexico',
    'ID': 'Indonesia',
    'TR': 'Turkey',
    'NL': 'Netherlands',
    'SA': 'Saudi Arabia',
    'CH': 'Switzerland',
    'PL': 'Poland',
    'SE': 'Sweden',
    'BE': 'Belgium',
    'AR': 'Argentina',
    'TH': 'Thailand',
    'AT': 'Austria',
    'NO': 'Norway',
    'IR': 'Iran',
    'ZA': 'South Africa',
    'DK': 'Denmark',
    'SG': 'Singapore',
    'MY': 'Malaysia',
    'CL': 'Chile',
    'UA': 'Ukraine',
    'SK': 'Slovakia',
    'BG': 'Bulgaria',
    'EE': 'Estonia',
    'LT': 'Lithuania',
    'NZ': 'New Zealand',
    'LV': 'Latvia',
    'CZ': 'Czech Republic',
    'IS': 'Iceland',
    'RO': 'Romania',
    'HR': 'Croatia',
    'MT': 'Malta',
    'HU': 'Hungary',
    'CY': 'Cyprus',
    'SI': 'Slovenia',
    'PT': 'Portugal',
    'IE': 'Ireland',
    'GR': 'Greece',
    'FI': 'Finland',
    'LU': 'Luxembourg',
    'MA': 'Morocco',
    'BQ': 'Caribbean Netherlands',
    'IO': 'British Indian Ocean Territory',
    'EG': 'Egypt',
    'BD': 'Bangladesh',
    'MG': 'Madagascar',
    'BA': 'Bosnia and Herzegovina',
    'VN': 'Vietnam',
    'PE': 'Peru',
    'CI': 'Ivory Coast',
    'GL': 'Greenland',
    'LI': 'Liechtenstein',
    'AM': 'Armenia',
    'MN': 'Mongolia',
    'MD': 'Moldova',
    'UY': 'Uruguay',
    'RS': 'Serbia',
    'GE': 'Georgia',
    'FO': 'Faroe Islands',
    'GP': 'Guadeloupe',
    'PH': 'Philippines',
    'BO': 'Bolivia',
    'TN': 'Tunisia',
    'MU': 'Mauritius'
  },
  'menu': {
    'compte': 'My account',
    'informations': 'My information',
    'commandes': 'My orders',
    'factures_et_avoirs': 'My invoices',
    'bons_de_livraison': 'My delivery notes',
    'preferences': 'My preferences',
    'changer_de_client': 'Change customer',
    'deconnecter': 'Log out',
    'contacts': 'My contacts',
    'mes_droits': 'My rights',
    'mes_droits_synako': 'Sales rep selection',
    'commandes_passees': 'My past orders',
    'passer_commande': 'Place order',
    'egalim': 'My ÉGalim',
  },
  'egalim': {
    'titre': 'My ÉGalim Dashboard',
    'synthese_titre': 'ÉGalim purchase summary',
    'montant_total': 'Total',
    'montant_euro': '{{montant}}€',
    'dont_bio': 'of which Organic',
    'dont_egalim': 'of which ÉGalim',
    'sur_montant_achat': 'out of {{montant}}€ purchases',
    'bio': 'Organic',
    'pourcentage_bio': '{{pourcentage}}% (Bio)',
    'pourcentage_egalim': '{{pourcentage}}% (ÉGalim)',
    'egalim': 'ÉGalim',
    'labels_officiels': 'Official ÉGalim labels',
    'labels_eligibles': 'Eligible labels',
    'labels_eligibles_info':
      'These “eligible” labels recognised by some administrations are selected by the client, who chooses whether or not to include them in their statistics',
    'labels_eligibles_selectionnes': 'Selected eligible labels',
    'aucun': 'none',
    'poids_kg': '{{poids}} Kg',
    'details_par_label': 'Purchase details by label',
    'exporter': 'Export my ÉGalim summary (.xls)',
    'periode_debut': 'Start',
    'periode_fin': 'End',
    'selection_periode': 'Select a period',
    'redirection_web': 'Find all your ÉGalim indicators on the web version of France Frais Connect:\n\u2022 View your BIO and ÉGalim rates in real time\n\u2022 Check the details by label (Bio, Label Rouge, AOP…)\n\u2022 Export your ÉGalim summary as .xls\n\u2022 Access your purchase and volume history by period\n\nTo enjoy all these features, log in from a computer at the usual France Frais Connect address, then open the "Mon ÉGalim" section.',
    'redirection_web_illustrations': 'Here are some illustrations of what you can find on the web in your "Mon ÉGalim" section:',
    'montant_achat_total': 'Total amount',
  },
  'menu_livraison': {
    'tooltip': 'Click to order for another date.',
    'livraison': 'Delivery on <strong>{{date}}</strong>'
  },
  'bon_de_livraison': {
    'numero_de_commande': 'Order number',
    'date_de_commande': 'Order date',
    'total_de_commande': 'Order total',
    'bon_de_livraison_titre': 'Delivery note',
    'commande': 'Order',
    'action': 'Action',
    'telecharger': 'Download',
    'telecharger_tout': 'Download all',
    'bon_de_livraison': '{{count}} DELIVERY NOTE',
    'bon_de_livraison_one': '{{count}} DELIVERY NOTE',
    'bon_de_livraison_other': '{{count}} DELIVERY NOTES',
    'bon_de_livraison_many': '{{count}} DELIVERY NOTES',
    'bon_de_livraison_plural': '{{count}} DELIVERY NOTES',
    '2_derniers_mois': 'Last 2 months',
    '3_6_mois': '3 to 6 months',
    'N°': 'No.',
    'aucun_bon_de_livraison': 'You have no delivery notes for this period.'
  },
  'liste': {
    'mes_listes': 'My lists',
    'produits_par_saison': 'My seasonal products',
    'offre_commercial': 'Recommended for me',
    'operation_commerciale': {
      'titre': 'Currently',
      'aucune': 'No ongoing commercial operation'
    },
    'devis_personnalise': {
      'titre': 'Sales proposal',
      'selection_commercial': 'Selection prepared by your sales representative',
      'selection_commercial_avec_nom': 'Selection prepared by {{prenom}} {{nom}}',
      'aucun_devis': 'No sales proposal available',
      'note_commercial': 'Note from your sales representative',
      'mis_a_jour_le': 'Updated on {{date}}',
      'voir_devis': 'View the sales proposal',
      'euro_ht': '€ excluding tax/',
      'votre_commercial': 'Your sales representative',
      'vous': 'You',
      'commentaires': 'Messages',
      'ecrire_commentaire': 'Write your message',
      'commentaire_envoye_succes': 'Message sent successfully',
      'commentaire_requis': 'Message is required',
      'nouveau_message': '{{count}} new message',
      'nouveau_message_one': '{{count}} new message',
      'nouveau_message_other': '{{count}} new messages',
      'non_lu': '{{count}} unread',
      'non_lu_one': '{{count}} unread',
      'non_lu_other': '{{count}} unread',
      'non_lu_many': '{{count}} unread',
      'non_lu_plural': '{{count}} unread',
      'voir_plus': 'see more',
      'messages_commercial': 'Messages from your sales representative'
    },
    'creer_liste': 'Create a new list',
    'veuillez_entrer_nom_liste': 'Please enter the name of the new list',
    'veuillez_entrer_nouveau_nom_liste': 'Please enter the new list name',
    'nom_liste_placeholder': 'New list name',
    'liste_supprimee': 'The list {{nom}} has been deleted',
    'liste_renommee': 'The List has been renamed',
    'syntaxe_nom_liste': 'Only letters, numbers and spaces are allowed',
    'ajouter_a_une_liste': 'Add to a list',
    'ajouter_au_cadencier': 'Add to Reorder List',
    'aria_label_modifier': 'Modify list name',
    'aria_label_enregistrer': 'Save new list name',
    'aria_label_renommer': 'Rename list',
    'chargement_listes': 'Loading your lists',
    'ajouter_article': 'Add an item',
    'veuillez-selectionner-ou-ajouter-larticle': 'Please select where to add the item',
    'editer_nom_liste': 'Edit list name',
    'supprimer_liste_confirm': 'Are you sure you want to delete this list?',
    'supprimer_liste_action': 'Delete list',
    'mois': {
      'tout': 'All'
    },
    'par_periode': 'By period',
    'categorie': 'Category',
    'frequence_achat': 'Purchase frequency',
    'filtre': {
      'selection_date': 'Select a period',
      'date_debut': 'Start date',
      'date_fin': 'End date',
      'appliquer': 'Apply',
      'reinitialiser': 'Reset'
    },
    'ajouter_a_la_liste': 'Add to list',
    'dans_la_liste': 'In the list',
    'dans_le_cadencier': 'In the reorder list',
    'aucun_produit': 'No product in this list',
    'selection_liste': 'Select a list',
    'ajouter_produits': 'Add products to',
    'choisir_une_liste': 'Choose a list',
    'tooltip_ajouter_cadencier': 'Add products to cadencier',
    'produit_ajoute': 'Product added to the list',
    'aucune_liste': 'No list selected',
    'commande_x_fois': 'Ordered {{count}} times',
    'produit_deja_dans_liste': 'Product already in the list',
    'selectionner_liste_tooltip': 'Select a list to add the product',
    'quantite_saisonniere_tooltip': 'Sum of deliveries over the selected period',
    'date_range': {
      'select': 'Period',
      'selection': '',
      'debut': 'Start date',
      'fin': 'End date',
      'effacer': 'Clear',
      'valider': 'Confirm',
      'changer': 'Change'
    },
    'mes_produits': 'My products',
    'produits_par_saison_short': 'By season',
    'selectionner_liste_pour_ajout': 'Select a list to add products',
    'liste': 'List:',
    'historique_achat': 'Purchase history',
    'trouver_alternative': 'Replace'
  },
  'operation_commerciale': {
    'voir_details': 'Discover',
    'retour': 'Back',
    'jusqu_au': 'Until {{date}}',
    'article_hors_base': 'Article in commercial operation but not in FF database ({{code_article}})'
  },
  'back_office': {
    'comment_ca_marche': 'How does it work?',
    'unauthorized': 'You must be logged in with your France Frais email.',
    'clients_ouverts': 'Open Status',
    'chercher_client': 'Search for a customer',
    'metier': 'Business',
    'representant': 'Sales rep',
    'liste_operations_commerciales': 'Sales campaigns',
    'liste_clients': 'Customers',
    'clients_avec_panier': 'With open cart',
    'adresse_depot': 'Pickup warehouse address',
    'adresse_magasin': 'Store address',
    'liste_societes_commerciales': 'List of commercial companies',
    'nom_etablissement': 'Establishment name',
    'etablissement': 'Establishment',
    'statut_tolede': 'Tolede status',
    'statut_tolede_ok': 'OK',
    'kpis': {
      'total_client': 'Total clients',
      'connexion': 'Connection',
      'connectes': 'Connected',
      'non_connectes': 'Not connected',
      'commandes': 'Orders',
      'ayant_commande': 'Ordered',
      'nayant_pas_commande': 'Not ordered',
      'toggle': {
        'trente_jours': 'Last 30 days',
        'depuis_debut': 'Since beginning',
      },
    },
    'livraisons': 'Deliveries',
    'livraisons_sans_tournee': {
      'label': 'No delivery rounds',
      'description': 'When no delivery round is configured in Tolede, customers cannot access France Frais Connect.',
    },
    'filiale': 'subsidiary',
    'paniers': 'Carts',
    'paniers_origine': {
      'client': 'Customer',
      'representant': 'Sales rep',
      'processus_pdf': 'PDF import',
    },
    'paniers_origine_description': {
      'client': 'Carts opened by the customer',
      'representant': 'Carts opened by the sales rep',
      'processus_pdf': 'Carts from a PDF order import',
    },
    'panier_en_cours': 'Current cart',
    'statut': 'Status',
    'nombre_commandes': 'Number of orders',
    'statut_tooltip': 'Tolede business rule to determine if customer can order in Tolede or not (independent of digital aspect)',
    'paniers_tooltip': 'Number of open carts',
    'cgv': 'Terms and Conditions',
    'pas_de_client': 'No customer',
    'prochaine_date_livraison': 'Next delivery on {{date_de_livraison}}',
    'cutoff_non_disponible': 'Cut off not available',
    'rafraichir_clients': 'Refresh customer list',
    'rafraichir_clients_tooltip': "Refreshes the company's customer list.",
    'invitation_envoyee_le': 'Invitation sent on {{date}}',
    'relance_envoyee_le': 'Reminder sent on {{date}}',
    'email_ouvert_le_tooltip': 'Seen on {{date}}',
    'envoyer_relance_tooltip': 'Send a reminder to {{email}}',
    'envoyer_invitation_tooltip': 'Send an invitation to {{email}}',
    'relance_message_placeholder': 'Your personalized message... (optional)',
    'envoyer_email_relance': 'Send email',
    'relance_titre': 'Reminder to order on France Frais connect',
    'liste_emails_relance': 'To:',
    'historique_invitation': 'Invitation history',
    'historique_relance': 'Reminder history',
    'historique_emails_titre': 'Email history',
    'email_ouvert_le': 'email opened on {{date}}',
    'pas_historique_email': 'Tracking details are no longer available (expired after 45 days)',
    'actions_client': {
      'conversations': 'Conversations',
      'etat_activation': 'Activation status',
    },
    'etat_activation': {
      'contacts': 'Contacts',
      'connecte_le': 'Connected - {{date}}',
      'invitation_envoyee_le': 'Invitation sent - {{date}}',
    },
    'activation_statut': {
      'connecte': 'Connected',
      'non_connecte': 'Not connected',
      'sans_email': 'No email',
      'a_commande': 'Has ordered',
      'na_pas_commande': "Hasn't ordered",
    },
    'multicanal': 'Active multi-channel',
    'activation': 'FFConnect status',
    'activation_tooltip': {
      'titre': 'FFConnect activity status over the last 30 days ({{periode}})',
      'connecte': 'Connected: signed in to FFConnect.',
      'a_commande': 'Has ordered: order validated via FFConnect.',
      'na_pas_commande': "Hasn't ordered: connected but no FFConnect order.",
      'non_connecte': 'Not connected: no sign-in over the period.',
      'sans_email': "No email: no email known (can't send an invitation).",
      'note': 'Orders entered directly into Tolede are not counted.',
    },
    'jamais_validé': 'Never validated',
    'details_client': {
      'retour_clients': 'Back to client list',
      'assistance_client': 'Customer view',
      'prendre_une_commande': 'Take an order',
      'voir_les_statistiques': 'View statistics',
      'informations_livraison': 'Delivery information',
      'informations_societe': 'Company information',
      'jours_de_livraison': 'Delivery days',
      'semaine_paire': 'Even week',
      'semaine_impaire': 'Odd week',
      'client_actionnaire': 'Shareholder client',
      'tournees': 'Delivery rounds',
      'parametrages': 'Settings',
      'catalogue_client': 'Client catalogue',
      'rafraichir_catalogue': 'Refresh catalogue',
      'cadencier_tendances': 'Order list',
      'tendance': {
        'en_hausse_one': 'Rising',
        'en_hausse_other': 'Rising',
        'gagne_one': 'Won',
        'gagne_other': 'Won',
        'stable_one': 'Stable',
        'stable_other': 'Stable',
        'en_baisse_one': 'Falling',
        'en_baisse_other': 'Falling',
        'perdu_one': 'Lost',
        'perdu_other': 'Lost',
        'a_gagner_one': 'Not ordered',
        'a_gagner_other': 'Not ordered',
      },
      'paniers_ouverts': 'Open carts',
      'rempli_par': {
        'client': 'Client',
        'representant': 'Sales rep',
        'processus_pdf': 'PDF',
      },
      'mis_a_jour_le': 'Updated on {{date}}',
      'reprendre_le_panier': 'Resume cart',
      'consulter_le_panier': 'View cart',
      'dernieres_commandes': '{{count}} latest orders',
      'dernieres_commandes_one': '{{count}} latest order',
      'dernieres_commandes_other': '{{count}} latest orders',
      'dernieres_commandes_titre': 'Latest orders',
      'client_aucune_commande': 'The client has no orders',
      'toutes_les_commandes': 'All orders',
      'ub_essentielles': 'Essential UBs',
      'ub_statut': {
        'gagne_one': 'Active',
        'gagne_other': 'Active',
        'en_baisse_one': 'Falling',
        'en_baisse_other': 'Falling',
        'perdu_one': 'Lost',
        'perdu_other': 'Lost',
        'a_gagner_one': 'To win',
        'a_gagner_other': 'To win',
      },
      'informations_client': 'Customer information',
      'contacts': 'Contacts',
      'code_client': 'Customer account',
      'paniers': 'Carts',
      'panier_en_cours': 'Current cart',
      'pas_de_panier_en_cours': 'No current cart',
      'paniers_historique': 'Carts',
      'paniers_historique_aria': 'View carts history',
      'paniers_historique_vide': 'No cart event',
      'panier_event_id': 'Cart ID',
      'panier_event_statut': 'Cart status',
      'panier_event_date': 'Event date',
      'panier_event_message': 'Message',
      'panier_event_payload': 'Payload',
      'panier_event_valide': 'Validated',
      'panier_event_echec': 'Failed',
      'information_a_renseigner': 'Information must be entered in Tolede.',
      'rafraichissement': 'Refreshing...',
      'rafraichir_contacts': 'Refresh contacts',
      'rafraichir_contacts_tooltip': 'Updates the client contact list after a change or addition made in Tolede.',
      'rafraichir_catalogue_tooltip': 'Updates the changes made in Tolede regarding the client products and rates.',
      'affiche_dlc_modifie': 'The display of expiration dates has been modified.',
      'affichage_dlc': 'Show expiration dates',
      'affiche_produit_marche_modifie': 'The market product display has been modified.',
      'affichage_produit_marche': 'Show Market Products',
      'affiche_prix_ttc_modifie': 'The TTC price display has been modified.',
      'affichage_prix_ttc': 'Show TTC prices',
      'denomination_sociale': 'Company name',
      'pas_de_contact': 'No contact provided',
      'voir_tous_les_contacts': 'View all contacts',
      'adresse_precedente': 'Previous address',
      'adresse_suivante': 'Next address',
      'cgv_tooltip': 'Terms acceptance date',
      'profils_ub': 'Essential UB Profiles',
      'profils_ub_description': 'Essential Unit of Needs profiles associated with the client.',
      'gerer_profils_ub': 'Manage UB profiles',
      'profils_associes': '{{count}} associated profile',
      'profils_associes_one': '{{count}} associated profile',
      'profils_associes_other': '{{count}} associated profiles',
      'aucun_profil_associe': 'No associated profiles',
      'aucun_profil_associe_description': 'No Essential UB profiles are currently associated with this client. Click the edit icon to associate some.',
      'chargement_profils': 'Loading profiles...',
      'aucun_profil_disponible': 'No UB profiles available',
      'nombre_items': '{{count}} item',
      'nombre_items_one': '{{count}} item',
      'nombre_items_other': '{{count}} items',
      'message': 'Message',
      'date': 'Event date',
      'telecharger': 'Payload',
      'identifiant_panier': 'Cart ID',
      'statut_panier': 'Cart status',
      'quinze_derniers_jours': 'Over the last 15 days.',
      'validé': 'Validated',
      'nombre_produits': 'Number of products',
      'no_events': 'No cart validation or validation failure in the last 30 days.',
      'contacts_tooltip': 'List of contacts marked as web in Tolede who can access FFConnect',
      'panier_commercial': 'Sales cart',
      'erreur_inconnue': 'Unknown error'
    },
    'prise_de_commande': {
      'liste_clients': {
        'title': 'Order Taking',
        'reprendre_commande': 'Resume',
        'paniers': 'Carts',
        'paniers_tooltip': "List of in-progress carts created by a sales representative. The client's in-progress carts are visible in the client's profile.",
        'nouveau_panier': 'New cart',
        'livraison_date': 'Delivery on {{date}}',
        'aucun_panier': 'No cart',
        'article': '{{count}} item',
        'article_one': '{{count}} item',
        'article_other': '{{count}} items',
        'article_many': '{{count}} items',
        'article_plural': '{{count}} items',
        'total_ht': 'Total excluding tax: ',
        'derniere_maj': 'Last update on {{date}}',
        'derniere_commande': 'Last order',
        'aucun_client': 'No client found',
        'tooltip_aucune_livraison': 'No delivery date available for this client.',
        'commande_commerciale': 'Commercial order',
        'aucune_date_disponible': 'No delivery date available for this client.',
        'actions': 'Actions',
        'actions_tooltip': 'Create a new cart for your client.',
        'panier_commercial_en_cours_tooltip': 'Commercial cart in progress',
        'commande_commercial_existante_tooltip': 'Existing commercial order for this delivery day',
        'profil': '{{count}} profile',
        'profil_one': '{{count}} profile',
        'profil_other': '{{count}} profiles',
        'profil_many': '{{count}} profiles',
        'profil_plural': '{{count}} profiles'
      },
      'panier': {
        'promotions': 'Promotions',
        'catalogue': 'Catalog',
        'cadencier': 'Reorder List',
        'ub': 'Essential Need Unit',
        'tout': 'All ({{count}})',
        'panier_vide': 'The cart is empty!',
        'ajouter_articles_depuis': 'Add items from:',
        'date_de_livraison': 'Delivery date',
        'commander_autre_date': 'Order for another date',
        'adresse_de_livraison': 'Delivery address',
        'changer_adresse': 'Change delivery address',
        'reference_commande': 'Order reference',
        'chargement_tooltip': 'Loading data may take a few minutes.',
        'chargement_donnees': 'Loading your client data...',
        'voir_fiche_client': 'View client details',
        'differer_aussi_panier': 'Defer current cart products as well',
        'erreur_chargement': 'Error loading client data.',
        'stock': 'Stock: {{count}} {{unite}}',
        'dlc_stock_sans_donnees': 'No expiry date and stock data available for this item.',
        'prix_total': 'Total price',
        'prix_unite': 'Unit price',
        'prix_saisi': 'Entered price',
        'reinitialiser_prix': 'Reset price',
        'prix_post_promo': 'Post promo price: {{prix}} €',
        'prix_bloque': 'Integrate into derogation',
        'prix_bloque_label': 'To integrate into derog.',
        'marges_totales': 'MV <bold>{{vm}}</bold> / MR <bold>{{tm}}</bold> / MK <bold>{{mk}}</bold>',
        'prix_modifie_succes': 'Price successfully updated',
        'ajout_rapide': 'Quick add',
        'recherche_rapide': 'Search for a product...',
        'chargement_articles': 'Loading items',
        'soit': 'Which is',
        'profils': 'Profiles',
        'pas_de_produits': 'No products',
        'ub_status': {
          'a-gagner': 'To win',
          'en-baisse': 'Declining',
          'perdu': 'Lost',
          'gagne': 'Won',
          'ras': 'Stable'
        },
        'ub_status_nombre': {
          'a-gagner': '{{count}} to win',
          'en-baisse': '{{count}} declining',
          'perdu': '{{count}} lost',
          'gagne': '{{count}} won',
          'ras': '{{count}} stable',
          'perdu_one': '{{count}} lost',
          'perdu_many': '{{count}} lost',
          'perdu_other': '{{count}} lost',
          'perdu_plural': '{{count}} lost',
          'gagne_one': '{{count}} won',
          'gagne_many': '{{count}} won',
          'gagne_other': '{{count}} won',
          'gagne_plural': '{{count}} won',
          'ras_one': '{{count}} stable',
          'ras_many': '{{count}} stable',
          'ras_other': '{{count}} stable',
          'ras_plural': '{{count}} stable'
        },
        'ub_status_nombre_filtres': {
          'a-gagner': 'To win ({{count}})',
          'en-baisse': 'Declining ({{count}})',
          'perdu': 'Lost ({{count}})',
          'gagne': 'Won ({{count}})',
          'ras': 'Stable ({{count}})'
        },
        'ub_tooltip': 'Profiles can be modified from the client file.',
        'ub_section_regles': '<strong>Won</strong>: at least one UB product ordered once in the last 30 days.<br/><strong>Lost</strong>: no product ordered in the UB in the last 30 days compared to the previous 30 days.<br/><strong>Declining</strong>: 30% decrease in UB product weight in the last 30 days compared to the previous 30 days.<br/><strong>To win</strong>: no UB product ordered in the last 60 days.',
        'ub_section_tooltip': 'Sub-sub family of the nomenclature:<br/> {{nom_famille}}',
        'confirmation_degradation_prix_metier': {
          'titre': 'Confirm business price degradation',
          'question': 'Are you sure you want to degrade the business price?',
          'info': '<bold>The business price is the most attractive price</bold>, it is the price applied according to the client\'s profession.',
          'annuler': 'Cancel',
          'degrader': 'Degrade the price',
        },
        'devis_personnalises': 'Custom quotes',
        'marges': 'Margins',
        'matching': 'Matching',
        'matching_titre': 'Matching report',
        'matching_non_disponible': 'Matching report not available',
        'ajouter_au_panier': 'Add product'
      },
      'confirmation': {
        'commande_confirmee': 'Order confirmed!',
        'livraison_du': 'Delivery on {{date}}',
        'message_confirmation': 'You can view the order details at any time in the "My orders" section of your client.',
        'terminer': 'Finish',
      },
      'drawer': {
        'ajouter_produits': 'Add products',
        'choisir_categorie': 'Choose a category',
        'aucun_produit_disponible': 'No product available',
        'ajouter': 'Add',
        'details_produit': 'Product details',
        'aucun_resultat_recherche': 'No search results',
        'fin_liste': 'End of list',
      },
      'aucune_societe_commerciale': 'No commercial company available'
    },
    'pdf_order_import': {
      'title': 'PDF Order Import',
      'nouvel_import': 'New import',
      'chercher_client': 'Search for a client',
      'uniquement_echecs': 'Failures only',
      'aucun_processus_trouve': 'No process found',
      'recherche_client': 'Client search',
      'placeholder_recherche_client': 'Enter client name or code (min. 3 characters)',
      'chargement_societe': 'Loading company data...',
      'erreur_chargement_societe': 'Error loading company data',
      'client_selectionne': 'Selected client',
      'changer': 'Change',
      'recherche': 'Searching...',
      'erreur_recherche_clients': 'Error searching for clients',
      'aucun_client_trouve': 'No client found',
      'id': 'ID',
      'fichier_pdf': 'PDF file',
      'erreur_fichier_pdf': 'The file must be a PDF',
      'veuillez_selectionner_pdf': 'Please select a PDF file',
      'fichier_invalide': 'The file must be of type {{types}}',
      'cliquez_ou_glissez_document': 'Click or drag the document here',
      'cliquez_ou_glissez_documents': 'Click or drag the document(s) here',
      'formats_acceptes': '{{formats}}',
      'processus_initie_succes': 'Process initiated successfully',
      'importer': 'Import',
      'rapport': 'Report:',
      'voir_details': 'View details',
      'nom_fichier': 'File name:',
      'taille_fichier': 'File size:',
      'taille_fichier_ko': '{{taille}} KB',
      'reference_pdf': 'PDF reference:',
      'erreur_chargement_processus': 'Error loading process',
      'date_initiation': 'Initiation date',
      'par': 'by {{utilisateur}}',
      'detail_processus': 'Process details',
      'statut': 'Status:',
      'cree_le': 'Created on:',
      'mis_a_jour_le': 'Updated on:',
      'modifier_panier': 'Go to cart',
      'transformer_en_panier': 'Transform into cart',
      'redemarrer_matching': 'Restart matching',
      'redemarrer_matching_avec_client': 'Restart matching with this client',
      'corriger_client': 'Correct client and restart matching',
      'erreur_detectee': 'Error detected:',
      'etape_non_executee': 'Step not yet executed',
      'voir_fichier_pdf': 'View PDF file',
      'resultat_badge': {
        'ok': 'OK',
        'echec': 'Failed ({{nombre}}/{{total}})',
        'en_cours': 'In progress',
        'archive': 'Deleted',
        'commande_validee': 'Validated order',
        'panier': 'Cart',
        'non_defini': '-',
      },
      'etape': {
        'capture': 'Capture',
        'extract': 'Extraction',
        'match': 'Matching',
        'controle': 'Control',
        'panier': 'Cart',
        'statut': {
          'terminee': 'OK',
          'echouee': 'KO',
          'en_cours': 'In progress',
          'non_defini': '-',
        },
      },
      'relancer_processus': 'Restart process',
      'processus_relance_succes': 'Process restarted successfully',
      'processus_transforme_panier': 'Process transformed into cart',
      'matching_redemarre_succes': 'Matching restarted successfully',
      'archiver_processus': 'Delete',
      'processus_archive_succes': 'The process has been deleted',
      'archiver_confirmation': {
        'titre': 'Delete this import?',
        'texte':
          'The import and its PDF file will be deleted. This action cannot be undone.',
        'titre_avec_panier': 'Delete this import and its cart?',
        'texte_avec_panier':
          'The cart created from this import will be deleted, with all its lines. This action cannot be undone.',
        'valider_avec_panier': 'Delete the import and the cart',
      },
      'filtre': {
        'mes_imports': 'My imports',
        'initie_par': 'Initiated by',
        'client': 'Client',
        'statut': 'Status',
        'statut_en_cours': 'In progress',
        'statut_erreur': 'Error',
        'statut_panier': 'Cart',
        'statut_commande_validee': 'Validated order',
      },
      'columns': {
        'date_reception_id': 'RECEPTION DATE / PDF',
        'lance_par': 'INITIATED BY',
        'client': 'CLIENT',
        'statut': 'STATUS'
      },
      'extract': {
        'erreur_plusieurs_commandes': 'The PDF contains multiple different delivery dates',
        'erreur_qualite_insuffisante': 'The PDF file quality is insufficient to extract data',
        'erreur_annotations_manuscrites': 'The PDF contains handwritten annotations',
        'erreur_pas_une_commande': 'The document is not an order form',
        'erreur_annulation_article': 'The document is a cancellation request',
        'erreur_demande_avoir': 'The document is a credit note request',
        'erreur_aucune_ligne': 'No product line was extracted from the PDF',
        'voir_donnees_extraites': 'View extracted data',
        'nom_client': 'Client name',
        'numero_client': 'Client number',
        'code_ur_client': 'UR Code',
        'date_de_livraison': 'Delivery date',
        'adresse_de_livraison': 'Delivery address',
        'numero_bon_commande': 'Order reference',
        'date_creation': 'Creation date',
        'destinataire': 'Recipient',
        'nombre_lignes': 'Number of lines',
        'autres_informations': 'Other information',
        'non_renseigne': 'Not provided',
        'adresse_emetteur': 'Sender address',
        'adresse_facturation': 'Billing address',
        'contact_emetteur': 'Sender contact',
        'contact_adresse_livraison': 'Delivery address contact',
        'contact_adresse_facturation': 'Billing address contact',
        'informations_de_livraison': 'Delivery information',
        'signature_client': 'Client signature',
        'prix_total': 'Total price',
        'lignes': 'Product lines',
        'nom': 'Name',
        'prenom': 'First name',
        'email': 'Email',
        'telephone': 'Phone',
        'fonction': 'Function',
        'point_livraison_specifique': 'Specific delivery point',
        'horaire_livraison_specifique': 'Specific delivery time',
        'autres_informations_livraison': 'Other delivery information',
        'nom_prenom': 'Full name',
        'date': 'Date',
        'total_ht': 'Total ex. VAT',
        'total_tva': 'Total VAT',
        'total_ttc': 'Total inc. VAT',
        'numero_ligne_pdf': 'PDF line number',
        'texte_entree': 'Original text',
        'code_article_extrait': 'Product code',
        'libelle_extrait': 'Label',
        'quantite_commandee': 'Quantity',
        'coefficient_commande_client_vers_facturation': 'Coefficient',
        'unite_commande': 'Order unit',
        'unite_facturation': 'Billing unit',
        'prix_unitaire_extrait': 'Unit price',
        'prix_total_extrait': 'Total price',
        'marque_extraite': 'Brand',
        'exception_plusieurs_commandes': 'Multiple orders',
        'exception_qualite_suffisante': 'Sufficient quality',
        'exception_annotations_manuscrites': 'Handwritten annotations',
        'exception_est_une_commande': 'Is an order',
        'exception_annulation_article_commande_passee': 'Cancellation request for past order',
        'exception_demande_avoir': 'Credit note request',
        'exception_prix_total_incoherent': 'Inconsistent total price',
        'siret_client': 'SIRET client',
        'format_pdf': 'PDF Format',
        'confiance_metadata': 'metadata',
        'confiance_text': 'text',
        'confiance_fallback': 'heuristic',
      },
      'match': {
        'exception': {
          'qualite_insuffisante': 'The PDF file quality is insufficient',
          'annotations_manuscrites': 'The PDF contains handwritten annotations',
          'pas_une_commande': 'The document is not a purchase order',
          'demande_avoir': 'The document is a credit note request',
          'annulation_commande': 'The document is a cancellation request',
          'plusieurs_commandes': 'The PDF contains several delivery dates',
          'aucune_ligne_extraite': 'No product line could be extracted',
          'prix_total_incoherent':
            'The sum of the lines differs from the total amount.',
          'fichier_doublon':
            'File already processed on {{date_doublon}} at {{heure_doublon}}, initiated by {{utilisateur_initiateur}}.',
          'fichier_doublon_lien': 'View the process',
          'client_non_matche': 'No matching client found',
        },
        'exceptions_titre': 'Alerts and exceptions',
        'client_titre': 'Client',
        'client_code': 'Client code',
        'client_raison_sociale': 'Company name',
        'date_de_livraison': 'Delivery date',
        'date_extraite': 'Extracted date',
        'date_matchee': 'Matched date',
        'date_valide': 'Valid date',
        'date_invalide': 'Invalid date',
        'date_livraison.validee': 'Delivery date extracted and validated',
        'date_livraison.aucune_tournee_correspond': 'No delivery tour matches the date specified by the client.',
        'date_livraison.date_inferieure_aujourdhui': 'The delivery date specified by the client is earlier than today',
        'date_livraison.absente': 'No delivery date on the purchase order: the first available delivery tour was selected.',
        'adresse_de_livraison': 'Delivery address',
        'adresse_extraite': 'Extracted address',
        'adresse_matchee': 'Matched address',
        'aucune_adresse_matchee': 'No address matched',
        'mode_unique': 'Unique client address',
        'mode_bm25': 'BM25 match',
        'mode_default': 'Default selection',
        'adresse_non_verifiee': 'Address not verified - low match',
        'etat_badge_ok': 'OK',
        'etat_badge_alerte': 'To check',
        'etat_badge_bloquant': 'To check first',
        'adresse_ok': 'Address validated',
        'adresse_alerte': 'Address to verify',
        'adresse_bloquant': 'Address to validate in Tolède',
        'statistiques': 'Statistics',
        'lignes_ok': 'OK lines',
        'lignes_avertissement': 'To check',
        'lignes_bloquant': 'To check first',
        'lignes': 'Order lines',
        'aucune_ligne': 'No lines',
        'code_deduit': 'Deduced code',
        'code_exact': 'Exact code',
        'libelle_different': 'Different label',
        'quantite_incoherente': 'Incoherent quantity',
        'quantite_incoherente_detail': 'Multiple: {{multiple}}, PDF quantity: {{quantite_pdf}}',
        'quantite_ajustee_suggestion': 'Suggested: {{quantite_ajustee}}',
        'prix_different': 'Different price ({{ecart}}%)',
        'unite_incoherente': 'Incoherent unit',
        'unite_incoherente_detail': '{{unite_pdf}} → {{unite_catalogue}}',
        'unite_inconnue': 'Unknown',
        'unite_raison_incompatible_units': 'Incompatible units',
        'unite_raison_unknown_unit': 'Unit not recognized in PDF',
        'unite_raison_regle_de_trois_ok': 'Accepted (rule of three OK)',
        'hors_cadencier': 'Outside price list',
        'dans_cadencier': 'In price list',
        'article_non_trouve': 'Article not found',
        'donnees_pdf': 'PDF data',
        'prix_pdf': 'PDF price',
        'prix_catalogue': 'Catalog price',
        'libelle_pdf': 'PDF label',
        'libelle_catalogue': 'Catalog label',
        'similarite': 'Similarity',
        'faible_similarite': 'Low similarity',
        'comparaison_libelle': 'Label comparison',
        'score_tooltip': 'Confidence: {{score}}%',
        'nombre_lignes_coherent': 'Line count consistent',
        'nombre_lignes_coherent_tooltip': 'PDF: {{pdf}}, Extracted: {{extraites}}',
        'nombre_lignes_incoherent': 'PDF: {{pdf}}, Extracted: {{extraites}}',
        'prix_total_titre': 'Total price',
        'prix_total_pdf': 'PDF price (excl. tax)',
        'prix_total_pdf_ttc': 'PDF price (incl. tax)',
        'prix_total_calcule': 'Calculated price',
        'prix_total_coherent': 'Amounts consistent',
        'prix_total_incoherent': 'Difference of {{ecart}}%',
        'voir_comparaison_detaillee': 'View detailed data comparison',
        'colonne_champ': 'Field',
        'colonne_valeur_pdf': 'PDF value',
        'colonne_valeur_matchee': 'Deduction',
        'colonne_statut': 'Result',
        'champ_texte_entree': 'Raw information',
        'champ_code_article': 'Article code',
        'champ_libelle': 'Label',
        'champ_unite_commande': 'Order unit',
        'champ_unite_facturation': 'Billing unit',
        'champ_quantite': 'Quantity',
        'champ_prix_unitaire': 'Unit price',
        'champ_prix_total': 'Total price',
        'champ_cadencier': 'In Price Schedule',
        'code_article_client_info': 'Client code: {{code}}',
        'code_generique_info': 'Generic code: {{code}}',
        'quantite_multiple_info': 'Order multiple: {{multiple}}',
        'ligne_colonne_numero': 'N°',
        'ligne_colonne_code': 'Code',
        'ligne_colonne_libelle': 'Label',
        'ligne_colonne_qte': 'Qty',
        'ligne_colonne_prix_u': 'Unit Price',
        'ligne_colonne_prix_ligne': 'Line Price',
        'badge_code': 'Code',
        'badge_code_exact': 'Exact',
        'badge_code_non_trouve': 'Not found',
        'badge_code_manquant': 'Missing',
        'badge_libelle': 'Label',
        'badge_libelle_exact': 'Exact',
        'badge_libelle_partiel': 'Partial',
        'badge_libelle_non_reconnu': 'Not recognized',
        'badge_prix_ligne': 'Line price',
        'badge_prix_ligne_ok': 'OK',
        'badge_prix_ligne_alerte': 'Warning',
        'badge_prix_ligne_ko': 'Inconsistent',
        'badge_prix_unitaire': 'Unit price',
        'badge_dans_cadencier': 'In schedule',
        'badge_hors_cadencier': 'Out of schedule',
        'tooltip_similarite': 'Similarity: {{score}}%',
        'tooltip_ecart': 'Deviation: {{ecart}}%',
        'client_mode_auto': 'Automatic detection',
        'client_mode_preselectionne': 'Preselected',
        'client_confiance': 'Confidence',
        'client_donnees_extraites': 'Data extracted from PDF',
        'client_donnees_matchees': 'Identified client',
        'client_siret': 'SIRET',
        'client_numero': 'Client number',
        'client_nom': 'Client name',
        'client_adresse_livraison': 'Delivery address',
        'client_adresse_facturation': 'Billing address',
        'client_etapes_matching': 'Matching steps',
        'client_candidats': 'Candidates',
        'client_candidats_restants': '{{count}} candidate(s)',
        'client_candidats_partial': 'Candidates ({{displayed}} of {{total}})',
        'client_candidats_all': 'Candidates ({{total}})',
        'client_score': 'Score',
        'client_criteres': 'Matched criteria',
        'client_non_renseigne': 'Not provided',
        'client_valeur_recherchee': 'Searched value',
        'critere_utilise': {
          'siret': 'SIRET',
          'code_client': 'Client code',
          'adresses_livraison_facturation': 'Delivery/billing addresses',
          'raison_sociale': 'Company name',
        },
        'critere_match': {
          'siret_exact': 'Exact SIRET',
          'numero_client_exact': 'Exact client number',
          'adresse_bm25': 'Address (BM25)',
          'nom_bm25': 'Name (BM25)',
        },
        'tooltip': {
          'etat_final': 'Final state: {{etat}}',
          'identification': 'Identification: {{etat}}',
          'code_detail': '• Code: {{etat}} {{valeur}}',
          'libelle_detail': '• Label: {{etat}}',
          'prix_ligne_detail': 'Line price: {{etat}}',
          'etat': {
            'ok': 'OK',
            'alerte': 'WARNING',
            'bloquant': 'BLOCKING'
          },
          'code': {
            'exact': 'EXACT',
            'non_trouve': 'NOT FOUND',
            'manquant': 'MISSING'
          },
          'libelle': {
            'exact': 'EXACT ({{percentage}}%)',
            'partiel': 'PARTIAL ({{percentage}}%)',
            'non_reconnu': 'NOT RECOGNIZED ({{percentage}}%)'
          },
          'prix': {
            'ok': 'OK',
            'alerte': 'WARNING ({{ecart}})',
            'ko': 'KO ({{ecart}})',
            'vide': 'No price to compare'
          },
          'regle': {
            'prix_absent': 'No price to compare → WARNING',
            'prix_bloquant': 'Line price > {{threshold}}% → BLOCKING',
            'code_exact_libelle_ok': 'Code EXACT + Label OK → OK',
            'code_exact_libelle_ko': 'Code EXACT + Label KO → BLOCKING (suspected conflict)',
            'libelle_exact_compense_code': 'Label EXACT compensates for missing code → OK',
            'pas_code_libelle_partiel': 'No code + Label PARTIAL → WARNING',
            'ni_code_ni_libelle': 'No reliable code or label → BLOCKING',
            'prix_alerte': 'Line price ≤ {{threshold}}% → WARNING',
            'evaluation_standard': 'Standard evaluation'
          }
        }
      }
    },
    'menu': {
      'clients': 'Clients',
      'commandes': 'Orders',
      'catalogue_grand_compte': 'France Frais catalog',
      'operations_commerciales': 'Sales Promotions',
      'commandes_pdf': 'PDF Orders',
      'devis': 'Quotes',
      'conversations': 'Conversations',
      'changelog': 'Changelog',
      'roadmap': 'Roadmap',
      'maintenance': 'Maintenance',
      'administration_fonctionnalites': 'Feature access',
      'retour_accueil': 'Back to companies list'
    },
    'administration_fonctionnalites': {
      'delai_cache': 'Changes apply within one minute.',
      'acces_refuse': 'You do not have access to this page.',
      'succes': 'Change saved',
      'clients_actionnaires': {
        'titre': 'Shareholder clients',
        'description':
          'Configured for even or odd weeks. Upload the Excel file (Code Tolède and SEMAINE LIVRAISON columns) to fully replace the list.',
        'format_excel': 'Expected Excel format',
        'compteur_one': '{{count}} client configured',
        'compteur_other': '{{count}} clients configured',
        'compteur_plural': '{{count}} clients configured',
        'importer': 'Upload Excel file',
        'succes':
          'Import done: {{count}} row(s) applied, {{inconnus}} unknown code(s), {{invalides}} rejected row(s).',
      },
      'ajouter': 'Add',
      'aucun_email': 'No email',
      'aucun_resultat': 'No results for “{{recherche}}”',
      'recherche_email_placeholder': 'Search for an email…',
      'compteur_emails_one': '{{count}} email',
      'compteur_emails_other': '{{count}} emails',
      'compteur_emails_plural': '{{count}} emails',
      'supprimer_email': 'Remove email',
      'email_placeholder': 'email@example.com',
      'actif': 'Enabled',
      'inactif': 'Disabled',
      'toutes_les_societes': 'All companies',
      'aucune_societe': 'No company',
      'ajouter_societes': 'Add companies',
      'supprimer_societe': 'Remove company',
      'ou': 'OR',
      'actif_pour_tous': 'Enabled for everyone',
      'societes_autorisees': 'Authorized companies',
      'utilisateurs_autorises': 'Authorized users',
      'utilisateurs_operations_nationales': 'National promotion users',
      'administrer_utilisateurs': 'Administer feature users',
      'phrase_utilisateurs': 'This list can be edited only when “Enabled for everyone” is off.',
      'zones': {
        'deploiement': 'Rollout',
        'administrateurs': 'Administrators',
        'delegues': 'Who can manage access',
      },
      'categories': {
        'operations_commerciales': 'Sales promotions',
        'commandes_pdf': 'PDF orders',
        'prise_de_commande': 'Order taking',
        'mode_commercial': 'Sales mode',
        'devis_tarifaires': 'Custom quotes',
        'ub_essentielles': 'Essential need units',
        'conversations': 'Conversations',
        'egalim': 'Egalim',
        'roadmap': 'Roadmap',
        'maintenance': 'Maintenance',
        'sandbox': 'SBX access',
        'tolede': 'Tolède',
      },
      'cles': {
        'operation_commerciale_test_users': 'Test emails',
        'operation_commerciale_nationale_authorized_users': 'National promotion administrators',
        'operation_commerciale_enable': 'Enabled for everyone',
        'societe_commerciale_operation_commerciale_autorisee': 'Authorized companies',
        'pdf_order_import_test_users': 'Test emails',
        'pdf_order_import_enabled': 'Enabled for everyone',
        'prise_de_commande_test_users': 'Test emails',
        'prise_de_commande_enable': 'Enabled for everyone',
        'societe_commerciale_prise_de_commande_autorisee': 'Authorized companies',
        'mode_commercial_test_users': 'Test emails',
        'mode_commercial_enable': 'Enabled for everyone',
        'societe_commerciale_mode_commercial_autorisee': 'Authorized companies',
        'devis_tarifaires_test_users': 'Test emails',
        'devis_tarifaires_enable': 'Enabled for everyone',
        'societe_commerciale_devis_tarifaires_autorisee': 'Authorized companies',
        'ub_essentielles_test_users': 'Test emails',
        'ub_essentielles_enable': 'Enabled for everyone',
        'societe_commerciale_ub_essentielles_autorisee': 'Authorized companies',
        'conversations_test_users': 'Test emails',
        'conversations_enable': 'Enabled for everyone',
        'conversations_toutes_enable': 'Access to all conversations',
        'societe_commerciale_conversations_autorisee': 'Authorized companies',
        'egalim_test_users': 'Test emails',
        'egalim_enable': 'Enabled for everyone',
        'societe_commerciale_egalim_autorisee': 'Authorized companies',
        'roadmap_authorized_users': 'Authorized emails',
        'maintenance_authorized_users': 'Authorized emails',
        'sbx_authorized_users': 'Authorized emails',
        'tolede_authorized_users': 'Emails allowed in safelive',
        'tolede_unauthorized_users': 'Emails excluded in normal mode',
        'delegues': 'Who can manage access',
      },
    },
    'conversations': {
      'titre': 'Conversations',
      'nouvelle_conversation': 'New conversation',
      'initier_conversation': 'Create a conversation',
      'commencer_conversation': 'Start conversation',
      'client': 'Client',
      'rechercher_client_placeholder': 'Search for a client (min. 3 characters)',
      'personne_a_contacter': 'Client contact',
      'personne_a_contacter_chez': 'Contact at {{raison_sociale}}',
      'selectionner_contact': 'Select a contact',
      'message': 'Message',
      'message_placeholder': 'Write your message...',
      'erreur_recherche_client': 'Search error',
      'aucun_client_trouve': 'No client found',
      'aucun_contact_disponible': 'No contact available for this client',
      'erreur_creation': 'Error creating conversation',
      'conversation_avec': 'Conversation with {{raison_sociale}}',
      'chez': 'at',
      'hier': 'Yesterday',
      'conversations_en_cours': 'conversation_one in progress',
      'conversations_en_cours_one': 'conversation in progress',
      'conversations_en_cours_other': 'conversations in progress',
      'aucune_conversation': 'No conversation in progress.',
      'aucune_conversation_terminee': 'No ended conversation.',
      'selectionner_conversation': 'Select a conversation',
      'sans_titre': 'No title',
      'cloturer': 'End conversation',
      'aucun_message': 'No messages in this conversation.',
      'zone_saisie_placeholder': 'Input area (coming soon)',
      'participant_commercial': '{{nom}} (sales rep)',
      'placeholder_message': 'Type your message',
      'conversation_terminee_info': 'This conversation has ended. You can reopen it by sending a message.',
      'envoyer': 'Send',
      'ajouter_piece_jointe': 'Add document',
      'ajouter_image': 'Add image',
      'piece_jointe': 'Attachment (optional)',
      'taille_fichier_ko': '{{taille}} KB',
      'format_non_supporte': 'File format "{{nom}}" is not supported (accepted formats: JPEG, PNG, GIF, WebP, PDF, Word, Excel)',
      'modifier_titre': 'Edit title',
      'inviter_collaborateur': 'Invite a collaborator',
      'collaborateur': 'Collaborator',
      'rechercher_collaborateur': 'Search for a collaborator...',
      'aucun_collaborateur_trouve': 'No collaborator found',
      'aucun_collaborateur_disponible': 'No collaborator available',
      'message_invitation': 'Message (optional)',
      'message_invitation_placeholder': 'Custom message (optional)',
      'collaborateur_sans_email': 'The selected collaborator does not have a registered email address. They will not receive an invitation email.',
      'inviter': 'Invite',
      'en_cours': 'In progress',
      'terminees': 'Completed',
      'conversations_suivantes': 'See next conversations',
      'toutes_les_conversations': 'All conversations',
      'mes_conversations': 'My conversations',
      'conversations_terminees': 'Completed conversations',
      'lecture_seule': 'You are viewing this conversation in read-only mode',
      'contact_inconnu': 'Unknown contact',
      'contact_inconnu_tooltip': 'This contact is no longer associated with this company',
      'utilisateur_inconnu': 'Unknown user',
      'utilisateur_inconnu_tooltip': 'This collaborator is no longer available',
      'rejoindre_conversation': 'Join the conversation',
      'vous_avez_rejoint': 'You have joined the conversation',
    },
    'operations_commerciales': {
      'succee_dupliquer': 'Sales campaign successfully duplicated',
      'succee_modifier': 'Sales campaign successfully modified',
      'succee_archiver': 'Sales campaign successfully archived',
      'ajouter_article': 'Add items',
      'article_ajoute': 'Item added successfully',
      'erreur_ajout': 'Error adding item',
      'article_obsolete': 'Obsolete',
      'article_reserve': 'Reserved for {{codes}}',
      'article_reserve_hors_beneficiaires': 'None of the subsidiaries benefiting from this campaign is among the companies this item is reserved for',
      'buttons': {
        'creer': 'New campaign',
        'enregistrer_brouillon': 'Save as draft',
        'publier': 'Publish',
        'ajouter_article': 'Add',
        'deja_ajoute': 'Already added',
        'archiver': 'Archive'
      },
      'creation': {
        'succee': 'Operation created successfully',
        'erreur_info': 'Error during sales campaign'
      },
      'modification': {
        'chargement': 'Loading commercial operation information',
        'lecture_seule_nationale': 'National campaign: you are viewing it as read-only. Only authorised people can edit it.',
        'lecture_seule': 'You are viewing this campaign as read-only.',
        'lecture_seule_archivee': 'Archived campaign: it can only be viewed. Duplicate it to reuse it.',
        'sauvegarde_automatique': 'Changes saved automatically',
      },
      'modale_filiales': {
        'titre': 'Add subsidiaries',
        'rechercher': 'Search for a subsidiary…',
        'disponibles': 'Available subsidiaries',
        'toutes': 'All',
        'toutes_info': 'Select all displayed subsidiaries',
        'nombre_disponibles_one': '{{count}} subsidiary',
        'nombre_disponibles_other': '{{count}} subsidiaries',
        'nombre_selectionnees_one': '{{count}} subsidiary selected',
        'nombre_selectionnees_other': '{{count}} subsidiaries selected',
        'aucun_resultat': 'No subsidiary matches your search.',
      },
      'modale_langues': {
        'titre': 'Add a language',
      },
      'modale_couleur': {
        'titre': 'Choose a color',
        'appliquer': 'Apply',
        'palette': 'Palette colors',
        'hex_label': '#',
        'rouge_label': 'R',
        'vert_label': 'G',
        'bleu_label': 'B',
        'hex_aria': 'Hexadecimal color code',
        'rouge_aria': 'Red component, from 0 to 255',
        'vert_aria': 'Green component, from 0 to 255',
        'bleu_aria': 'Blue component, from 0 to 255',
      },
      'modale_cadrage': {
        'titre': 'Adjust image framing',
        'enregistrer': 'Save',
        'tourner_gauche': 'Rotate the image a quarter turn to the left',
        'tourner_droite': 'Rotate the image a quarter turn to the right',
        'erreur_chargement':
          'The image could not be loaded: this panel will keep its current framing.',
        'aria_zone': 'Framing area: use the arrow keys to move it',
        'aria_poignee_nw': 'Top left handle: use the arrow keys to resize',
        'aria_poignee_ne': 'Top right handle: use the arrow keys to resize',
        'aria_poignee_se':
          'Bottom right handle: use the arrow keys to resize',
        'aria_poignee_sw': 'Bottom left handle: use the arrow keys to resize',
      },
      'modale_sous_metiers': {
        'titre': 'Sub-departments of {{metier}}',
        'nombre_selectionnes_one': '{{count}} sub-department selected',
        'nombre_selectionnes_other': '{{count}} sub-departments selected',
      },
      'langue': {
        'fr': 'French',
        'en': 'English',
        'de': 'German',
      },
      'portee': {
        'locale': 'Local',
        'nationale': 'National',
      },
      'modale_portee': {
        'titre': 'New sales campaign',
        'locale_description': 'Can be edited by every beneficiary subsidiary.',
        'nationale_description': 'Can only be edited by authorised people. Beneficiary subsidiaries see it as read-only.',
        'info': 'The scope cannot be changed afterwards.',
        'creer': 'Create',
      },
      'modale_archivage': {
        'titre': 'Archive the campaign',
        'message': 'The campaign will no longer be shown to customers and cannot be unarchived. For one year, it remains visible in the list with "Show archived campaigns" and can be duplicated.',
      },
      'form_info': {
        'operation_info': 'About the operation',
        'nom_label': 'Operation name',
        'nom_placeholder': 'Operation name',
        'description_label': 'Campaign description',
        'description_placeholder': 'Briefly describe the operation',
        'banniere_label': 'Banner',
        'banniere_info_text_part1': 'The image must come from the France Frais media library accessible',
        'banniere_info_text_link': 'here',
        'banniere_info_tooltip': 'If you do not have access to the media library, you can request it from {{email}}',
        'visuels_label': 'Operation visuals',
        'ordre_label': 'Display order',
        'metier_label': 'Departments',
        'visibilite_label': 'Visibility',
        'ciblage_label': 'Targeting',
        'filiales_label': 'Subsidiaries benefiting from the promotion',
        'filiales_info': 'Customers of each selected subsidiary can see the promotion. Only subsidiaries within your scope are offered.',
        'filiale_hors_perimetre': 'Subsidiary outside your scope, you cannot remove it.',
        'filiale_retirer': 'Remove the subsidiary',
        'filiale_derniere': 'A promotion must benefit at least one subsidiary.',
        'ajouter_filiale': 'Add a subsidiary',
        'voir_toutes_les_filiales': 'See all subsidiaries ({{count}})',
        'sous_metier_label': 'Targeted sub-departments',
        'sous_metier_info': 'With no sub-department selected, the promotion targets the whole department. Otherwise it targets only the selected sub-departments.',
        'ajouter_sous_metier': 'Add a sub-department',
        'article_liste_label': 'Product list',
        'ajouter_produits': 'Add products',
        'ajouter_produits_directement': 'Add products directly',
        'aucun_produit': 'No product yet',
        'traduction_label': 'Translation',
        'ajouter_langue': 'Add a language',
        'article_deja_present': "Article '{{code_article}}' already added",
        'article_inexistant': "Item '{{code_article}}' not found",
        'apercu_label': 'Preview',
        'apercu_ordinateur': 'Desktop',
        'apercu_mobile': 'Mobile',
        'ajuster_cadrage': 'Adjust image framing',
        'reinitialiser_cadrage': 'Reset framing',
        'compteur_caracteres': '{{longueur}}/{{max_length}}',
        'langue_retirer': 'Remove language',
        'image_ordinateur': 'Desktop image',
        'image_mobile': 'Mobile image',
        'format_recommande': 'Recommended format: 1920×1080 px JPG, PNG, WEBP • Max 5 MB',
        'glisser_ou_importer': 'Drag or import your image here',
        'couleur_banniere_label': 'Select the banner color',
        'choisir_couleur': 'Color {{couleur}}',
        'ajouter_couleur': 'Choose another color',
        'remplacer_image': 'Replace',
        'retirer_image': 'Remove the image',
        'envoi_image_en_cours': 'Uploading image...',
        'plage_date_label': 'Period',
        'selectionner_periode': 'Select a period',
        'plage_date_info': 'The period during which the campaign is shown to customers. Without a period, the campaign is not shown.',
        'affiche_date_fin_label': 'Show campaign end date to customers'
      },
      'columns': {
        'nom': 'Campaign',
        'ordre': 'Order',
        'statut': 'Status',
        'statut_info': {
          'visible': 'Visible: within its period, the campaign is shown to targeted customers.',
          'masquee': 'Hidden: with no period, or outside its period (over or yet to come), it is shown to no customer.',
          'archivee': 'Archived: it is shown to no customer and can no longer be edited, but it can be duplicated. It leaves the list one year after being archived.',
        },
        'portee': 'Scope',
        'portee_info': 'National: can only be edited by authorised people, beneficiary subsidiaries see it as read-only. Local: can be edited by every beneficiary subsidiary.',
        'articles': 'Items',
        'destinataires': 'Recipients',
        'actions': 'Actions',
        'plage_date': 'Period'
      },
      'nombre_metiers': '{{count}} department',
      'nombre_metiers_one': '{{count}} department',
      'nombre_metiers_other': '{{count}} departments',
      'aucun_metier': 'No department',
      'sous_metiers_du_metier': '{{metier}}: {{sous_metiers}}',
      'articles': {
        'un': '{{nb_produits}} item',
        'plusieurs': '{{nb_produits}} items',
      },
      'actions': {
        'publier': 'Publish',
        'depublier': 'Unpublish',
        'dupliquer': 'Duplicate',
        'archiver': 'Archive',
        'erreur_info': 'Error during action: {{scope}}'
      },
      'statut': {
        'publiee': 'Visible',
        'depubliee': 'Hidden',
        'archivee': 'Archived',
      },
      'chercher_operation': 'Search for a campaign…',
      'effacer_recherche': 'Clear search',
      'aucune_operation': 'No campaign to display.',
      'voir_archivees': 'Show archived campaigns',
      'plage_date_courte': '{{date_debut}} - {{date_fin}}'
    },
    'devis_personnalises': {
      'titre': 'Personalized quotes',
      'devis': 'Quote',
      'actions': 'Actions',
      'pas_de_devis_en_cours': 'No quote in progress',
      'nouveau_devis': 'New quote',
      'modifie_le': 'Modified on {{date}}',
      'aucun_client': 'No client found',
      'numero_devis': 'Quote {{numero}}',
      'devis_visible': 'Quote visible',
      'devis_masque': 'Quote hidden',
      'cree_le': 'Created on {{date}}',
      'envoyer_message_client': 'Send message to client',
      'repondre': 'Reply',
      'message_envoye_succes': 'Message sent successfully',
      'message_requis': 'Message is required',
      'contact_destinataire_requis': 'Please select a recipient contact',
      'contact_destinataire': 'Recipient contact',
      'choisir_contact': 'Choose a contact...',
      'nouveau_message_client': 'You have received {{count}} new message from your client',
      'nouveau_message_client_one': 'You have received {{count}} new message from your client',
      'nouveau_message_client_other': 'You have received {{count}} new messages from your client',
      'voir': 'View',
      'client': 'Client',
      'message': 'Message',
      'placeholder_message': 'Enter your message here...',
      'caracteres': 'characters',
      'tooltip_message_email': "- An email will be sent:<br/>Hello,<br/>[Content of your message]<br/>View quote button<br/>Best regards,<br/>Your signature<br/><br/>- [Content of your message] will be displayed in your client's quote on the FFConnect side",
      'historique': 'History',
      'historique_titre': 'Activity',
      'historique_tooltip': 'View activity',
      'historique_onglet_tout': 'All',
      'historique_onglet_visibilite': 'Visibility',
      'historique_onglet_articles': 'Items',
      'historique_onglet_messages': 'Messages',
      'historique_onglet_derogations': 'Derogations',
      'historique_tooltip_derogations': 'Derogation request or validation',
      'historique_aucun_evenement': 'No events in this category',
      'nouveaux_messages': 'new message',
      'nouveaux_messages_one': 'new message',
      'nouveaux_messages_other': 'new messages',
      'historique_vierge': 'No history at the moment',
      'evenement_fallback': 'Event: {{type}}',
      'evenement_non_defini': 'Undefined',
      'derniere_consultation': 'Last viewed by {{contact}}',
      'derniere_consultation_date': '{{date}}',
      'ajouter_produits': 'More products',
      'chargement_catalogue': 'Loading client catalog...',
      'demander_derogations': 'Request derogation',
      'injecter_derogations': 'Validate derogations',
      'info_demande_derogation': 'You are about to request approval for {{nombreDerogations}} derogation(s) for quote {{devisId}}.',
      'nombre_derogations_a_injecter': '{{nombre}} derogation(s) to inject',
      'date_fin_validite': 'End date',
      'date_fin_validite_placeholder': 'Select a date',
      'marges_ligne': 'MV <bold>{{vm}}</bold> / MR <bold>{{tm}}</bold> / M€/kg <bold>{{mk}}</bold>',
      'tooltip_marges': '<strong>MV (Margin Value):</strong> difference between catalog price and margin base (catalog price - margin base).<br/><strong>MR (Margin Rate):</strong> margin percentage ((MV / margin base) × 100).<br/><strong>M€/kg (Margin €/kg):</strong> margin per kilogram ((catalog price - margin base) / kg coefficient).',
      'date_fin_validite_aide': 'Derogations will be valid until this date',
      'injection_non_disponible': 'Injection not available',
      'injection_non_disponible_raisons': 'Injection is not possible: either you do not have the required permissions, there are no derogations to inject, or the quote is archived.',
      'manager_destinataire': 'Recipient manager',
      'choisir_manager': 'Choose a manager...',
      'saisir_email_manager': 'Enter manager email',
      'message_explicatif': 'Explanatory message',
      'message_placeholder': 'Please explain the reason for this derogation request...',
      'message_demande_derogation_defaut': 'Hello,\n\nI request your approval for {{nombreDerogations}} derogation(s).\n\nBest regards',
      'envoyer_demande': 'Send request',
      'envoi_en_cours': 'Sending...',
      'demande_derogation_envoyee': 'Derogation request sent successfully',
      'derogations_injectees_succes': 'Derogations successfully injected into Tolède',
      'prix_en_cours_actualisation': 'Prices are being updated',
      'refresh_catalogue': {
        'titre': 'Client catalog refresh',
        'message_principal': "We are updating your client's catalog so that the derogation prices are taken into account. This may take a few minutes.",
        'info_fermeture': 'If you close this modal, the catalog will continue to be updated and changes will be visible once the update is complete.',
        'succes_message': "Your client's catalog has been successfully updated. The new prices with derogations are now available."
      },
      'ajouter_au_devis': 'Add to quote',
      'ajout_rapide': 'Quick add',
      'recherche_rapide': 'Search for a product...',
      'article_ajoute_au_devis': 'The item has been successfully added to the quote',
      'liste_produits': 'Product list',
      'ajouter_une_note': '+ Add a note',
      'ajouter_une_note_placeholder': 'Add a note ...',
      'note_commerciale': "Salesperson's Note",
      'pre_remplir_plus_produit': "Pre-fill with the product's +",
      'prix': '{{prix}} €excl.tax/',
      'prix_dero_souhaite': 'Desired derogation price',
      'prix_dero_valide': 'Validated derogation price',
      'alerte_prix_plancher_depasse': '{{libelle}} ({{code_article}}): the entered price ({{prix_saisi}} €excl.tax) is below the floor price ({{prix_plancher}} €excl.tax)',
      'tarif_promotion': 'Promotion',
      'tarif_marche': 'Market',
      'tarif_derogation': 'Derogation',
      'tarif_general': 'General tariff',
      'tarif_metier': 'Trade price',
      'tarif_degagement': 'Clearance',
      'tarif_prix_en_cours': 'Current price',
      'tarif_non_precise': 'Not specified',
      'tarif_non_precise_tooltip':
        'Tolede did not provide the category of this price (general tariff, trade price, derogation…)',
      'aucun_tarif_disponible': 'No tariff available',
      'panel_prix_titre': 'Price',
      'panel_prix_categorie': 'Category',
      'panel_prix_prix': 'Price',
      'vider_le_devis': 'Empty quote',
      'vider_devis_confirmation': 'Are you sure you want to empty this quote? This action will remove all products from the quote.',
      'derniere_maj': 'Last updated on {{date}}',
      'devis_publie_succes': 'The quote is now visible to the client',
      'devis_depublie_succes': 'The quote has been hidden from the client',
      'devis_vide_succes': 'The quote has been emptied successfully',
      'archiver': 'Archive',
      'tooltip_archiver': 'By archiving this quote will no longer be visible or accessible.',
      'devis_archive_succes': 'The quote has been archived successfully',
      'aucun_produit_ancien_devis': 'No product found in previous quotes',
      'pas_encore_dans_tolede': 'Not yet in Tolede',
      'pas_encore_devis_tolede': 'Not yet a Tolede quote',
      'tooltip_pas_encore_devis': 'Not yet a Tolede quote: the quote is injected into Tolede when you click to request validation of desired derogations or when you validate the derogations or when you make the quote visible.',
      'tooltip_numero_devis': 'Tolede quote number',
      'tooltip_numero_devis_avec_tolede': 'Tolede quote number: {{numero}}',
      'devis_sans_nom': 'Quote of {{date}}',
      'nom_du_devis': 'Quote name',
      'nom_modifie_succes': 'The quote name has been modified successfully',
      'caracteres_restants': '{{count}} character remaining',
      'caracteres_restants_one': '{{count}} character remaining',
      'caracteres_restants_other': '{{count}} characters remaining',
      'tooltip_valider_derogations': 'By clicking, the desired derogations will be injected into Tolede.',
      'tooltip_demander_derogations': 'By clicking, you will be able to request validation of the desired derogations from your manager. The quote will also be injected into Tolede.',
      'tooltip_injecter_tolede': "Inject the quote into Tolede (items will be automatically added to the client's schedule).",
      'injecter_dans_tolede': 'Inject into Tolede',
      'devis_injecte_tolede_succes': 'The quote has been successfully injected into Tolede',
      'tooltip_devis_visibilite': "<strong>Quote visible enabled:</strong> your quote will be visible to the client from their France Frais Connect account and the items will be present in their Scheduler.<br/>Only one quote can be visible in the client's FFConnect space. If you have another visible quote, it will be hidden when making this quote visible.<br/><strong>Quote visible disabled:</strong> your quote is not visible to the client from their France Frais Connect account.",
      'onglet_devis_personnalises_tooltip': 'Items from previous personalized quotes',
      'tooltip_derogation_non_autorisée': 'Derogations are not authorized for this item',
      'erreur_modification_prix_promotion': 'Price modifications are not allowed on promotions',
      'erreur_modification_prix_marche': 'Price modifications are not allowed on market rates',
      'supprimer_prix_derogation': 'Remove the entered derogation price',
      'derogation_non_ajustable': 'Cannot modify price: non-adjustable derogation for this item',
      'dero_souhaitee_validee': 'Requested derogation validated',
      'dero_souhaitee_pas_encore_validee': 'Requested derogation not yet validated',
      'prix_promo_actuel': 'Discount price currently in effect: {{prix}} €',
      'historique_evenements': {
        'devis_cree': 'Quote created',
        'produit_avec_libelle_ajoute': 'Product "{{codeArticle}}" {{libelle}} added',
        'produit_ajoute': 'Product "{{codeArticle}}" added',
        'produit_ajoute_generique': 'Product added',
        'produit_avec_libelle_supprime': 'Product "{{codeArticle}}" {{libelle}} removed',
        'produit_supprime': 'Product "{{codeArticle}}" removed',
        'produit_supprime_generique': 'Product removed',
        'devis_vide': 'Quote cleared',
        'note_modifiee_avec_libelle': 'Note modified for "{{codeArticle}}" {{libelle}}',
        'note_modifiee': 'Note modified for "{{codeArticle}}"',
        'note_modifiee_generique': 'Note modified',
        'prix_modifie_complet': 'Price modified for "{{codeArticle}}" {{libelle}}: {{prixPrecedent}}€ → {{nouveauPrix}}€',
        'prix_modifie': 'Price modified for "{{codeArticle}}"',
        'prix_modifie_generique': 'Price modified',
        'devis_publie': 'Quote visible',
        'devis_publie_par': 'Quote made visible by {{auteur_nom}}',
        'devis_depublie': 'Quote hidden',
        'devis_depublie_par': 'Quote hidden by {{auteur_nom}}',
        'devis_archive': 'Quote archived',
        'message_commercial_envoye': 'Message sent by {{expediteur_nom}}',
        'message_commercial_avec_contenu': '{{expediteur_nom}} to {{destinataire_email}}',
        'message_commercial_envoye_generique': 'Message sent by sales representative',
        'commentaire_client_envoye': 'Comment sent by {{expediteur_nom}}',
        'commentaire_client_envoye_generique': 'Comment sent by client',
        'message_client_recu': '{{expediteur_nom}}',
        'message_client_recu_generique': 'Message received from client',
        'derogations_demandees_complet_one': '{{count}} exception request sent by {{expediteur_nom}} to {{email_manager}}',
        'derogations_demandees_complet_other': '{{count}} exception requests sent by {{expediteur_nom}} to {{email_manager}}',
        'derogations_demandees_par_one': '{{count}} exception request sent by {{expediteur_nom}}',
        'derogations_demandees_par_other': '{{count}} exception requests sent by {{expediteur_nom}}',
        'derogations_demandees_generique_one': '{{count}} exception request sent',
        'derogations_demandees_generique_other': '{{count}} exception requests sent',
        'derogations_injectees_par_one': '{{count}} exception injected by {{injecte_par_nom}}',
        'derogations_injectees_par_other': '{{count}} exceptions injected by {{injecte_par_nom}}',
        'derogations_injectees_generique_one': '{{count}} exception injected',
        'derogations_injectees_generique_other': '{{count}} exceptions injected',
        'devis_consulte_par': 'Quote viewed by {{contact}}',
        'devis_consulte': 'Quote viewed',
        'evenement_inconnu': 'Unknown event'
      },
      'mode_synako': 'Synako Mode',
      'mode_synako_demande': 'Derogation request mode',
      'mode_synako_injection': 'Derogation injection mode',
      'tooltip_message_email_demande_derogation': '- An email will be sent:<br/>Hello,<br/>[Content of your message]<br/>View quote button<br/>Best regards,<br/>Your signature<br/>',
      'message_demande_derogation_defaut_one': 'Can you validate my {{count}} derogation request?',
      'message_demande_derogation_defaut_many': 'Can you validate my {{count}} derogation requests?',
      'message_demande_derogation_defaut_other': 'Can you validate my {{count}} derogation requests?',
      'message_demande_derogation_defaut_plural': 'Can you validate my {{count}} derogation requests?'
    },
    'aucune_societe_commerciale': 'No commercial company available',
    'vide': 'No items',
    'maintenance': {
      'titleForm': 'Maintenance announcement',
      'form': {
        'date': 'Date',
        'heure_debut': 'Start time',
        'heure_fin': 'End time',
        'commence_le': 'Start date and time',
        'termine_le': 'End date and time',
        'commence_le_short': 'Starts on',
        'termine_le_short': 'Ends on',
        'message_fr': 'Message (FR)',
        'message_en': 'Message (EN)',
        'message_de': 'Message (DE)',
        'placeholder_message': 'Your message…',
        'jours_avant': 'Display how many days before (default 1)',
        'enregistrer': 'Save',
        'creer': 'Create a maintenance',
        'traduire': 'Translate into English and German',
      },
      'toast': {
        'success': 'Maintenance announcement saved',
        'traduction_echouee': 'Translation failed. Please try again.',
      },
      'preview': {
        'titre': 'Banner preview',
      }
    },
    'societes': 'Companies',
    'nouvelle_operation_commerciale': 'New campaign',
    'pdf_import': {
      'status': {
        'searching': 'Searching...',
        'matched_ok': 'Found',
        'not_found': 'Not found in catalog',
        'error': 'Error during search'
      },
      'mismatch': {
        'code': 'Article code different from catalog',
        'name': 'Label different from catalog'
      },
      'table': {
        'status': 'Status',
        'catalog_code': 'Catalog Code',
        'catalog_name': 'Catalog Name',
        'pdf_code': 'Code (extracted from PDF)',
        'pdf_name': 'Label (extracted from PDF)',
        'pdf_qty': 'Qty (extracted from PDF)',
        'pdf_unit': 'Unit (extracted from PDF)',
        'pdf_unit_price': 'Unit Price (extracted from PDF)'
      },
      'success_parse': 'PDF analyzed successfully',
      'error_invalid_type': 'Invalid file format',
      'error_no_file': 'No file selected',
      'error_client_not_ready': 'Client not selected',
      'parsing_pdf': 'Analyzing PDF ...',
      'title': 'Import a PDF order',
      'no_clients_available': 'No client available',
      'select_client_placeholder': 'Select a client...',
      'no_clients_found': 'No client found',
      'error_fetching_clients': 'Error fetching clients',
      'file_label': 'Order PDF file',
      'effacer_fichier': 'Clear file',
      'submit_button': 'Analyze PDF',
      'error_submission': 'Error analyzing the PDF.',
      'error_loading_index': 'Error loading client catalog.',
      'loading_index': 'Loading search index...',
      'searching_items': 'Searching for items...',
      'results_title': 'PDF analysis results',
      'delivery_date': 'Delivery date',
      'delivery_address': 'Delivery address',
      'order_reference': 'Order reference',
      'import_another': 'Import another file',
      'export_xlsx': 'Export as spreadsheet',
      'search_client_label': 'Search for a client'
    },
    'roadmap': {
      'toast': {
        'success': 'The roadmap has been updated'
      },
      'acceder': 'Access the FFConnect / FFCommerce Roadmap',
      'acces_refuse': 'Access restricted to the FFConnect project group.',
      'vide': 'No roadmap published yet.',
      'edition_titre': 'Edit the roadmap',
      'edition_aide':
        'Paste the full HTML code of the roadmap below. It will entirely replace the current content.',
      'placeholder': 'Paste the roadmap HTML code here…',
      'enregistrer': 'Save'
    },
    'changelog': {
      'titleForm': 'Changelog FFConnect',
      'toast': {
        'success': 'The changelog has been created successfully'
      },
      'form': {
        'title': 'Title',
        'placeholder_title': 'E.g.: FFConnect updates',
        'article_id': 'Article ID',
        'date': 'Date',
        'enregister': 'Save'
      }
    }
  },
  'metier': {
    'A1': 'SOCIAL CATERING',
    'A2': 'COMMERCIAL CATERING',
    'A3': 'TO REASSIGN B1 B2 B3 A2',
    'A4': 'SUPERMARKETS',
    'A5': 'SUBSIDIARIES / PERSONNEL',
    'A6': 'INDUSTRIAL WHOLESALERS',
    'A7': 'CONVENIENCE STORES',
    'B1': 'BAKERY PASTRY',
    'B2': 'CREAMERIES',
    'B3': 'BUTCHER DELICATESSEN CATERER',
    'B4': 'OTHER ARTISANS MERCHANTS',
    'E1': 'EXPORT TO RECLASSIFY',
    'P1': 'INDIVIDUALS'
  },
  'sous_metier': {
    'A1-11': 'Corporate',
    'A1-12': 'Schools',
    'A1-13': 'Healthcare',
    'A1-14': 'Social care',
    'A1-15': 'Leisure',
    'A1-16': 'Miscellaneous',
    'A2-21': 'Table service',
    'A2-22': 'Cafeteria',
    'A2-23': 'Fast food',
    'A2-24': 'Hotel',
    'A2-25': 'Transport catering',
    'A2-26': 'Leisure catering',
    'A2-27': 'Event caterer (no shop)',
    'A2-28': 'Marketplace',
    'A4-41': 'Convenience store',
    'A4-42': 'Supermarkets',
    'A4-49': 'Multi-fresh',
    'A4-50': 'Online sales',
    'A5-51': 'France Frais staff sales',
    'A5-52': 'Subsidiaries',
    'A6-61': 'Wholesalers',
    'A6-62': 'Manufacturers',
    'A6-63': 'Anaerobic digester / waste disposal',
    'A6-64': 'Carriers',
    'A7-1': 'Supermarket chain store',
    'A7-2': 'Independent convenience store',
    'B1-71': 'Baker and pastry chef',
    'B1-72': 'Baker',
    'B1-73': 'Pastry chef',
    'B1-74': 'Ice cream maker',
    'B1-75': 'Bake-off terminals',
    'B1-76': 'Chocolatier',
    'B1-77': 'Supermarket lab',
    'B2-81': 'Cheesemongers',
    'B2-82': 'Online sales',
    'B3-91': 'Butchers',
    'B3-94': 'Online sales',
    'B3-96': 'Poulterer / tripe',
    'B3-97': 'Horse butcher',
    'B3-98': 'Delicatessen / caterer with shop',
    'B3-99': 'Rotisserie',
    'B4-91': 'Fine grocery',
    'B4-92': 'Others (brewer, coffee roaster…)',
    'B4-97': 'Fishmonger',
    'B4-98': 'Greengrocer / market gardener',
    'B4-99': 'Online sales',
    'P1-57': 'MLC staff',
    'P1-58': 'Online individuals',
    'P1-59': 'Customer staff',
    'P1-60': 'Brigadiers',
    'P1-61': 'Individuals',
  },
  'activation': {
    'aucun_email': 'No email',
    'aucun_email_color': 'red.fail',
    'non_connecte': 'Not connected',
    'non_connecte_color': 'red.fail',
    'aucun_panier': 'No cart',
    'aucun_panier_color': 'orange.warning',
    'aucune_commande': 'No web order',
    'aucune_commande_color': 'orange.warning',
    'actif': 'Active',
    'actif_color': 'green.success',
    'connecte': 'Connected',
    'connecte_color': 'green.success',
    'ont_commande': 'Have ordered',
    'ont_commande_color': 'green.success'
  },
  'motif_de_blocage': {
    '01': '01 - Establishment closure',
    '02': '02 - Customer non-payment',
    '03': '03 - Unpaid invoice',
    '04': '04 - Customer assigned to another member',
    '05': '05 - Central office change',
    '06': '06 - Lost customer',
    '07': '07 - Receivership',
    '08': '08 - Change of ownership',
    '09': '09 - Central customer (non-billable)',
    '10': '10 - Other',
    '11': '11 - Account grouping',
    '12': '12 - Being duplicated',
    '13': '13 - Bailiff',
    '14': '14 - No revenue for 6 months',
    '15': '15 - Sale opposition',
    '16': '16 - Coface',
    '17': '17 - Judicial liquidation',
    '88': '88 - Credit limit exceeded',
    '89': '89 - Payment term exceeded',
  },
  'jours': {
    'dimanche': 'Sunday',
    'lundi': 'Monday',
    'mardi': 'Tuesday',
    'mercredi': 'Wednesday',
    'jeudi': 'Thursday',
    'vendredi': 'Friday',
    'samedi': 'Saturday',
  },
  'mes_informations': {
    'modification_alerte': 'Would you like to make a change?',
    'contacter_commercial': 'Contact your sales representative',
    'votre_commercial': 'Your sales representative',
    'mes_adresses': 'My addresses',
    'adresses_de_facturation': 'Billing addresses',
    'adresses_de_livraison': 'Delivery addresses',
    'adresse_de_retrait': 'Pickup address',
    'mon_identite': 'My identity',
    'mon_entreprise': 'My company',
    'mes_coordonnees': 'My contact details',
    'numero_de_compte': 'Account number:',
    'siret': 'SIRET:',
    'tva': 'VAT:',
    'par_mail': 'By email',
    'adresses_enlevement': 'Pickup addresses',
    'date_de_livraison': 'Delivery date:',
    'cut_off_de_preparation': 'Preparation cut off:',
    'les_tournees': 'Delivery routes',
    'tournee_enlevement': 'Pickup route #{{numero}}',
    'tournee_livrante': 'Delivery route #{{numero}}'
  },
  'contact': {
    'societe_commerciale': 'Commercial company',
    'televente': 'Telesales',
    'commercial': 'Sales representative',
    'copier_email': 'Copy email',
    'non_renseigne': 'Not specified'
  },
  'commande': {
    'nombre_commandes': '{{count}} ORDER',
    'nombre_commandes_one': '{{count}} ORDER',
    'nombre_commandes_other': '{{count}} ORDERS',
    'nombre_commandes_many': '{{count}} ORDERS',
    'nombre_commandes_plural': '{{count}} ORDERS',
    'commande': 'ORDER',
    'commande_one': 'ORDER',
    'commande_other': 'ORDERS',
    'commande_plural': 'ORDERS',
    '2_derniers_mois': 'Last 2 months',
    '3_6_mois': '3 to 6 months',
    'en_cours': 'In progress',
    'livrees': 'Delivered',
    'livree': 'Delivered',
    'annulees': 'Cancelled',
    'en_cours_de_traitement': 'Processing',
    'voir_le_detail': 'View details',
    'non_definie': 'Undefined',
    'saisie': 'Entered',
    'annulee': 'Cancelled',
    'ferme': 'Closed',
    'mise_en_prepa': 'In preparation',
    'prepa_en_cours': 'Preparation in progress',
    'prepa_terminee': 'Preparation completed',
    'facturee': 'Invoiced',
    'total_ttc': 'Total including tax',
    'total_ht': 'Total excluding tax',
    'total_tva': 'Total VAT',
    'livraison_du': 'Delivery on',
    'commande_du': 'Order from',
    'commande_marketplace_du': '{{marketplace}} order from',
    'date_de_commande': 'Order date',
    'passee_le': 'Order placed on',
    'adresse_facturation': 'Billing address',
    'adresse_livraison': 'Delivery address',
    'reference_de_commande': 'Order reference',
    'ajouter_produit': 'To add a product',
    'supprimer_produit_changer_quantite': 'To remove a product, change quantities',
    'passer_nouvelle_commande': 'Place a new order',
    'contacter_conseiller': 'Contact my advisor',
    'vous_etes_trompe': 'Made a mistake?',
    'on_vous_accompagne': "We'll help you.",
    'bon_de_commande': 'Purchase order',
    'details_de_ma_commande': 'My order details',
    'frais_de_livraison': 'Delivery fees',
    'n°': 'no.',
    'documents_non_disponibles': 'Documents not available',
    'modale_changer_adresse_header': 'Select your service',
    'digital': 'France Frais Connect',
    'ancien_web': 'Old Web',
    'televente': 'Telesales',
    'commercial': 'Sales representative',
    'ffcommerce': 'Sales representative (FFC)',
    'article': '{{count}} item',
    'article_one': '{{count}} item',
    'article_other': '{{count}} items',
    'article_many': '{{count}} items',
    'article_plural': '{{count}} items',
    'remplacer_article': 'Replace <strong>{{nom}}</strong>',
    'chercher_tout_catalogue': 'Search entire catalog',
    'voir_produits_ub': 'All products of the UB: {{nom}}',
    'chercher_dans_ub': 'Search within the UB',
    'aucun_produit_ub': 'No product matches your search',
    'remplacement_aucun_article': 'Sorry, no replacement item was found',
    'remplacement_aucun_produit_marche':
      'No market product found. Uncheck the “Market products” filter to see other items.',
    'remplacement_aucun_filtre': 'No items match the selected filters or search.',
    'par_multiple': 'by {{quantite}} {{unite}}',
    'par_colis': 'by package of {{quantite}} {{unite}}',
    'de_multiple_facturation': 'of {{multiple_facturation}} {{unite_facturation}}',
    'ajouter_cette_commande_panier': 'Add all items to cart',
    'ajouter_cette_commande_panier_tooltip': 'By clicking, all items will be added to a new cart for the currently selected delivery date.',
    'vous_souhaitez_renouveler_commande': 'Reorder',
    'gagner_temps': 'For a new delivery!',
    'a_payer': 'To pay',
    'payee': 'Paid',
    'aucune_commande': 'You have no orders for this period',
    'tooltip_tva': 'VAT amount',
    'produits': 'Products',
    'statut': 'Status',
    'statut_tooltip': 'Order status',
    'actions': 'Actions',
    'deja_commande': 'Already ordered:',
    'pour_livraison_du': 'For your delivery on {{date}}',
    'deja_commande_tooltip_ligne1': 'You have already ordered',
    'deja_commande_tooltip_ligne2': '<bold>{{quantite}} {{unite}}</bold> for <bold>{{date}}</bold>',
    'type': 'Order type',
    'articles_ajouter_au_panier': 'Products have been added to the cart with the same quantities.',
    'AF': 'CREDIT',
    'AV': 'CREDIT',
    'CA': 'ORDER',
    'CO': 'ORDER',
    'FC': 'ORDER',
    'FF': 'ADJUSTMENT',
    'FQ': 'ADJUSTMENT',
    'MD': 'MULTI RECIPIENT',
    'PD': 'ORDER',
    'PH': 'HISTORICAL FORECAST',
    'PR': 'FORECAST',
    'je_souhaite': 'I would like to',
    'ajouter_un_produit': 'Add a product',
    'je_passe_une_nouvelle_commande': 'I am placing a new order',
    'supprimer_produit_changer_quantites': 'Remove a product, change quantities',
    'je_contact_mon_conseiller': 'I contact my advisor',
    'renouveler_cette_commande': 'Renew this order',
    'j_ajoute_tous_ces_produits': 'I add all these products to my cart'
  },
  'factures_avoirs': {
    'facture': 'Invoice',
    'avoir': 'Credit note',
    'factures_et_avoirs': '{{count}} INVOICE AND CREDIT NOTE',
    'factures_et_avoirs_one': '{{count}} INVOICE AND CREDIT NOTE',
    'factures_et_avoirs_other': '{{count}} INVOICES AND CREDIT NOTES',
    'factures_et_avoirs_many': '{{count}} INVOICES AND CREDIT NOTES',
    'factures_et_avoirs_plural': '{{count}} INVOICES AND CREDIT NOTES',
    'facture_n°': 'Invoice no.',
    'date_emission': 'Issue date',
    'echeance': 'Due date',
    'total_ttc': 'Total including tax',
    'total_ht': 'Total excluding tax',
    'statut': 'Status',
    'action': 'Action',
    'telecharger': 'Download',
    'telecharger_tout': 'Download all',
    'n°': 'no.',
    'numero_de_facture': 'Invoice number',
    'factures': 'Invoices',
    'avoirs': 'Credit notes',
    'alerte': 'Warning! Invoice status is only updated once per day.',
    'aucune_facture_ou_avoir': 'No invoice or credit note available for this period.',
    '2_derniers_mois': 'Last 2 months',
    '6_derniers_mois': 'Last 6 months',
    '12_derniers_mois': 'Last 12 months'
  },
  'recherche': {
    'resultat_pour_mobile': 'Results for',
    'resultat_pour_desktop': 'Search results for ...',
    'recherche_produits': 'Search for a product',
    'chargement_catalogue': 'We are loading your catalog ...',
    'voir_tous_les_produits': 'View all products',
    'produits': 'Products',
  },
  'fiche_produit': {
    'description': 'Description',
    'caracteristiques': 'Characteristics',
    'dimensions_mm': 'Dimensions (mm)',
    'poids_net': 'Net weight',
    'poids_net_kg': '{{value}} kg',
    'table': {
      'ingredient_nutrition': 'Ingredients and nutrition',
      'informations_nutritionelles': 'Nutritional information',
      'pour100gml': 'Per 100 g/ml',
      'ajr': 'Recommended daily allowance (%)',
      'ingredients_manquants': 'The ingredients list has not yet been provided.',
      'allergenes': 'Allergens:',
      'ajr_short': 'AJR (%)'
    },
    'fiche_produit_pdf': {
      'telecharger_fiche_produit': 'Download product sheet.',
      'fiche_produit_non_disponible': 'Product sheet not available',
      'fiche_produit': 'Product sheet',
      'fiche_technique_pdf': 'Technical sheet.pdf'
    },
    'apercu_produit': 'Product preview',
    'voir_detail_produit': 'View product details'
  },
  'select_client': {
    'greeting': 'Great to see you again!',
    'selectionnez_compte': 'Select a customer account to continue',
    'client_de': 'Customer of {{nom_societe}}',
    'mon_catalogue_france_frais': 'My France Frais catalog'
  },
  'menu_catalogue': {
    'suggestion_produit': 'Current suggestions',
    'catalogues_partenaires': 'Partner catalogue products',
    'catalogue_MATFER01': 'Matfer Catalog'
  },
  'catalogue': {
    'aucun_produit': 'No products in this section!',
    'les_promotions': 'Promotions',
    'les_indispensables': 'Essentials',
    'indispensables': 'Essentials',
    'promotions': 'Promotions',
    'promotion_du_moment': 'Current promotions',
    'voir_tout_promotion': 'See all promotions',
    'voir_tout': 'View all',
    'plus_de_produit': 'More products',
    'commander_maintenant': 'Order now',
    'commander_maintenant_pour': 'Order now for',
    'produits_marque_proprietaire': 'Essentials',
    'fin_liste': 'End of your catalog',
    'filtre': {
      'promotions': 'Promotions',
      'produit_marche': 'Market products',
      'promo': 'Promo',
      'labels': 'Labels',
      'origine': 'Origin',
      'a-z': 'A - Z',
      'pertinence': 'Relevance',
      'tri': 'Sort:',
      'filtrer': 'Filter',
      'trier': 'Sort',
      'trier_par': 'Sort by',
      'afficher': 'Display',
      'tout_effacer': 'Clear all',
      'non_surgele_surgele': 'Non-frozen/Frozen',
      'non_surgele': 'Non-frozen',
      'surgele': 'Frozen',
      'effacer': 'Clear all filters',
      'afficher_marketplace': 'Partner catalogs',
      'no_labels': 'No labels',
      'sourcing': 'Sourcing',
      'fromage': 'Cheese characteristics',
      'famille_fromage': 'Cheese type',
      'type_de_lait': 'Milk type',
      'traitement_thermique_du_lait': 'Milk treatment',
    }
  },
  'fromage': {
    'famille': {
      'CH': 'Goat cheese',
      'FF': 'Processed cheese',
      'PF': 'Fresh cheese',
      'PMCF': 'Soft cheese, bloomy rind',
      'PMCL': 'Soft cheese, washed rind',
      'PP': 'Blue cheese',
      'PPC': 'Hard pressed cheese',
      'PPNC': 'Semi-hard pressed cheese',
    },
    'lait': {
      'BR': 'Sheep',
      'BU': 'Buffalo',
      'CH': 'Goat',
      'CB': 'Goat-Sheep',
      'VA': 'Cow',
      'VB': 'Cow-Sheep',
      'VC': 'Cow-Goat',
      'VCB': 'Cow-Goat-Sheep',
    },
    'traitement': {
      'LMF': 'Microfiltered milk',
      'LC': 'Raw milk',
      'LP': 'Pasteurized milk',
      'LS': 'Sterilized milk',
      'LT': 'Thermized milk',
      'LCLT': 'Thermized and raw milk',
    },
  },
  'accueil': {
    'bonjour': 'Hello {{nom}}!',
    'salutation': {
      'bonjour': 'Hello {{prenom}},',
      'bonjour_sans_prenom': 'Hello,',
      'pret_a_commander_chez': 'ready to order from {{societe}}?',
      'pret_a_commander': 'ready to order?',
    },
    'mes_dernieres_commandes': 'My latest orders',
    'cartes': {
      'cadencier': {
        'sous_titre': 'Your recurring products',
      },
      'listes': {
        'sous_titre': 'Your favourite products',
      },
      'saison': {
        'sous_titre': 'Products you ordered this time last year',
      },
    },
    'pastille_client': {
      'aria_label': 'Delivery point: {{raison_sociale}}, {{ville}}',
      'aria_label_sans_ville': 'Delivery point: {{raison_sociale}}',
    },
    'image_ambiance': {
      'alt': 'Atmosphere photo for your trade',
    },
    'chargement_catalogue': 'We are loading your catalog. During your first connection, this may take 2 minutes, thank you for your patience.',
    'chargement_tournees': 'Loading your delivery routes',
    'compte_bloque': 'Your account is not configured to take orders, please contact your representative.',
    'mes_paniers_en_cours': 'My current carts ({{nombre_paniers}})',
    'paniers_en_cours': 'Current carts ({{nombre_paniers}})',
    'afficher_paniers': 'Show all my carts',
    'voir_paniers': 'View',
    'pour_livraison': 'For delivery on ',
    'operation_commerciale': {
      'titre': 'Currently',
      'voir_tout': 'View all'
    },
    'devis_personnalises': {
      'titre': 'My sales proposal',
      'prepare_par_label': 'Prepared by',
      'prepare_par_commercial': 'Prepared by {{prenom}} {{nom}} — updated on {{date}}',
      'voir_le_devis': 'View the quote',
      'votre_commercial': 'Your sales representative ',
      'mise_a_jour': 'Updated on {{date}}',
      'nouveau_message': '{{count}} new message',
      'nouveau_message_one': '{{count}} new message',
      'nouveau_message_other': '{{count}} new messages',
      'messages': '{{count}} message',
      'messages_one': '{{count}} message',
      'messages_other': '{{count}} messages',
      'messages_singulier': '{{count}} message',
      'messages_pluriel': '{{count}} messages',
      'nouveau_message_singulier': '{{count}} new message',
      'nouveau_message_pluriel': '{{count}} new messages'
    }
  },
  'footer': {
    'conseiller_ecoute': 'Here to help',
    'conseiller_ecoute_grand_compte': 'Contact your sales representative',
    'mail': 'By email',
    'telephone': 'By phone',
    'consulter_rayons': 'Browse our departments',
    'nos_rayons': 'Our departments',
    'a_propos': 'About',
    'contactez_nous': 'Contact us',
    'tel': 'Tel.',
    'e_mail': 'Email.',
    'votre_conseiller': 'Your advisor:',
    'mentions_legales': 'Legal notice',
    'engagements': 'Our commitments',
    'politique_confidentialite': 'Privacy policy',
    'gestion_cookies': 'Cookie management',
    'cgv': 'Terms and Conditions',
    'cgu': 'Terms of Use'
  },
  'informations_legales': {
    'titre': 'Legal information',
    'consulter': 'View',
    'lien_externe': 'External link',
    'document_pdf': 'PDF document',
    'cgv': 'Terms and Conditions of Sale',
    'cgu': 'Terms of Use'
  },
  'modale_nomenclature': {
    'chargement': 'Loading your menu'
  },
  'modale_enlevement': {
    'contacter_representant': "To organize the pickup of your goods, don't forget to contact your representative"
  },
  'modale_differer': {
    'deplacement': 'Your product will be <strong>moved to the cart for {{date_de_livraison}}</strong>',
    'aucune_livraison_possible': 'No delivery available at the moment after this date.'
  },
  'preferences': {
    'alertes': 'My order alerts',
    'activer': 'Enable all',
    'email': 'Email',
    'mobile': 'Mobile app',
    'livraison': 'Next delivery reminder (the day before)',
    'livraison_mobile': 'Next delivery reminder<br />(the day before)',
    'paniers': 'Cart validation reminder',
    'mode_assistance_01': 'Preferences in the customer account are specific to each contact and are not global to the customer. <strong>It is therefore not possible to modify these preferences from assistance mode.</strong>',
    'mode_assistance_02': 'If a contact wishes to modify their preferences, they must log in to France Frais Connect themselves and manage them in the "My preferences" section.'
  },
  'session': {
    'session_bientot_expiree': 'Session expiring soon',
    'prolonger_session': 'Extend session',
    'prolongation': 'Extending...',
    'delai_expiration': 'Your session will expire in {{minutes}} minutes.'
  },
  'form': {
    'file_drop_zone': {
      'erreur_taille_fichier': 'The file exceeds the maximum allowed size (5 MB)',
      'erreur_envoi_fichier': 'The file upload failed, please try again.'
    },
    'societe_commerciale': {
      'titleAjouter': 'Add a commercial company',
      'titleModifier': 'Modify a commercial company',
      'dropzone': 'Drop your file or click on the area',
      'ajouter': 'Add',
      'modifier': 'Modify',
      'ajoutee': 'The commercial company has been registered.',
      'modifiee': 'The commercial company has been modified.',
      'supprimer': 'Delete',
      'ajouter_lien': 'Add a link',
      'annuler': 'Cancel',
      'valider': 'Confirm',
      'general': 'General information',
      'id_base_label': 'Base ID',
      'id_base_placeholder': 'Select base ID',
      'code_societe_commerciale_label': 'Commercial company code',
      'code_societe_commerciale_placeholder': 'Select company code',
      'nom_commercial_label': 'Trade name',
      'nom_commercial_placeholder': 'Company trade name',
      'ffconnect': 'FFConnect information',
      'permettre_commande_retrait_label': 'Allow order pickup',
      'permettre_commentaire_commande_label': 'Allow order comment',
      'permettre_traduction_allemande_label': 'Allow German translation for commercial operations',
      'message_validation_livraison_label': 'Delivery validation message',
      'message_validation_livraison_placeholder': 'Message for delivery validation',
      'message_validation_enlevement_label': 'Pickup validation message',
      'message_validation_enlevement_placeholder': 'Message for warehouse pickup validation',
      'contact': 'Contact information',
      'adresse_label': 'Address',
      'adresse_placeholder': 'Company address',
      'telephone_label': 'Phone',
      'telephone_placeholder': 'Company phone',
      'email_label': 'Email',
      'email_placeholder': 'Company email',
      'visuel': 'Visual information',
      'couleur_label': 'Company main color',
      'logo_label': 'Company logo (jpg or png)',
      'cgv_label': 'Company Terms and Conditions (pdf)',
      'reinitialiser_cgv': 'Reset Terms and Conditions acceptances',
      'reinitialiser_cgv_tooltip': 'Resets Terms and Conditions acceptances for all customers of this company. They will need to accept the Terms and Conditions again.',
      'reinitialiser_cgv_modal': {
        'titre': 'Reset Terms and Conditions acceptances',
        'message': 'Are you sure you want to reset the Terms and Conditions acceptances for all customers of this company? They will need to accept the Terms and Conditions again on their next order.',
        'confirmer': 'Reset',
        'annuler': 'Cancel'
      },
      'cgu_label': 'Company Terms of Use (pdf)',
      'footer': 'Footer information',
      'url_lien': 'URL for the link',
      'label_lien': 'Link label'
    }
  },
  'commercial': {
    'retour_fiche_client': 'Back to the customer card',
    'commandes_pdf': 'PDF Orders',
    'mode_commercial': 'Commerce view',
    'mode_client': 'Customer view',
  },
  'kpis': {
    'erreur': 'Error loading KPIs',
    'total_clients': 'Total customers',
    'nb_connectes': 'Connected customers',
    'nb_connectes_tooltip': '• {{nb_connectes}} customers connected to FFConnect in the last 30 days.<br />• {{nb_connectes_total}} customers connected to FFConnect since the beginning.',
    'non_connecte': 'not connected',
    'non_connecte_tooltip': 'Customers who have not connected to FFConnect in the last 30 days.',
    'avec_panier': 'Who created a cart',
    'avec_panier_tooltip': '• {{periode_en_cours}} customers created a cart on FFConnect in the last 30 days.<br />• {{nb_avec_panier_total}} customers created a cart on FFConnect since the beginning.',
    'sans_panier': 'no cart',
    'sans_panier_tooltip': "Customers who haven't created a cart on FFConnect in the last 30 days.",
    'panier_valide': 'Who validated a cart',
    'panier_valide_tooltip': '• {{periode_en_cours}} customers validated a cart on FFConnect in the last 30 days.<br />• {{nb_panier_valide_total}} customers validated a cart on FFConnect since the beginning.',
    'sans_commande': 'no web order',
    'sans_commande_tooltip': "Customers who haven't ordered on FFConnect in the last 30 days.",
    'tendance_tooltip': 'Trend over the last 30 days compared to the previous 30 days.',
    'clients_pas_connectes': 'Clients not connected',
    'clients_pas_commande': 'Clients who have not ordered',
    'clients_pas_connectes_tooltip': '• {{x30}} clients who have not connected to FFConnect in the last 30 days<br />• {{xEver}} clients who have not connected to FFConnect since the beginning',
    'clients_pas_commande_tooltip': '• {{x30}} clients who have not ordered on FFConnect in the last 30 days among connected clients<br />• {{xEver}} clients who have not ordered on FFConnect since the beginning among connected clients'
  },
  'analytics': {
    'modale_consentement_titre': 'Would you like to contribute to improving France Frais Connect by sharing usage statistics?',
    'amelioration_france_frais_connect': 'Improve France Frais Connect',
    'j_accepte_le_partage': 'I accept sharing'
  },
  'maintenance': {
    'title': 'Maintenance in progress',
    'contact_support': 'For any questions, please contact technical support.'
  },
  'historique_livraison': {
    'title': 'Purchase history',
    'aucun_historique': 'No purchase history available.',
    'historique_achat': 'Purchase history',
    'historique_achat_tooltip': 'Purchase history of the product over the last 90 days.',
    'pas_historique_achat_recent': 'No recent history',
    'derniers_achats': 'Last 5 purchases',
    'voir_plus': 'See more',
    'prix': 'Price',
    'categorie': 'Category',
    'prix_unitaire': '€{{prix}} excl. tax/{{unite}}',
    'prix_unitaire_avec_quantite': '{{quantite}} {{uniteQuantite}} at €{{prix}} excl. tax/{{unite}}',
    'evolution': {
      'en-hausse': {
        'titre': 'Line on the rise',
        'description': 'Weight ordered in the last 30 days ({{p1}}) has risen by at least 30 % compared to the previous 30 days ({{p2}}).',
      },
      'gagne': {
        'titre': 'Line won',
        'description': 'Ordered in the last 30 days ({{p1}}) while it was not ordered in the previous 30 days ({{p2}}).',
      },
      'stable': {
        'titre': 'Line stable',
        'description': 'Quantity ordered in the last 30 days ({{p1}}) is similar to the previous 30 days ({{p2}}) (variation under 30 %).',
      },
      'en-baisse': {
        'titre': 'Line declining',
        'description': 'Weight ordered in the last 30 days ({{p1}}) has dropped by at least 30 % compared to the previous 30 days ({{p2}}).',
      },
      'perdu': {
        'titre': 'Line lost',
        'description': 'Not ordered in the last 30 days ({{p1}}) while it was ordered in the previous 30 days ({{p2}}).',
      },
      'a-gagner': {
        'titre': 'Line not ordered',
        'description': 'Not ordered in the last 60 days ({{p3}}).',
      },
    },
  },
  'grand_compte': {
    'chercher_un_produit': 'Search for a product',
    'decouvrez_nos_gammes': 'Discover our product ranges',
    'categories': 'All departments',
    'sav_question': 'You have a question?',
    'erreur_categories': 'Error loading categories',
    'conditionnement': 'Packaging',
    'voir_details': 'View details',
    'rechercher_placeholder': 'Search for a product',
    'affiner_par_rayons': 'Refine by department:',
    'resultats': 'Results:',
    'reference': 'Referenced',
    'detention': 'Distribution',
    'nombre_societes_one': '{{count}} company',
    'nombre_societes_other': '{{count}} companies',
    'reference_par': {
      'groupe': 'National',
      'filiale': 'Subsidiary'
    },
    'detention_section': {
      'title_one': 'Distribution - marketed in {{count}} company',
      'title_other': 'Distribution - marketed in {{count}} companies',
      'title_many': 'Distribution - marketed in {{count}} companies',
      'title_plural': 'Distribution - marketed in {{count}} companies',
      'societe_commerciale': 'Commercial company',
      'vendu_3_derniers_mois': 'Sold in the last 3 months',
      'vendu_3_derniers_mois_tooltip': 'Quantities sold in the last 3 months',
      'aucune_societe_vendu': 'No company has sold this product in the last 3 months'
    }
  },
  'calendar': {
    'weekdays': {
      'short': [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
      ]
    }
  },
  'codes': {
    'code_client': 'Customer article code:',
    'code_generique': 'Generic code:'
  },
  'debug': {
    'produit_marche': {
      'titre': 'Debug Market Product',
      'client_id': 'Customer ID:',
      'charger_infos': 'Load general information',
      'statut_affichage_produit_marche_bo': 'Market product display in BO',
      'affichage_produit_marche': 'Market product display:',
      'tester_un_article': 'Test an article',
      'tester_article': 'Test the article',
      'test_article': 'Article test:',
      'statistiques_catalogue': 'Catalog statistics',
      'total_articles_catalogue': 'Total articles in catalog',
      'articles_produit_marche': 'Market product articles',
      'pourcentage_produit_marche': 'Percentage of market product articles',
      'metriques': 'Metrics',
      'valeur': 'Value',
      'existe_catalogue': 'Exists in catalog',
      'produit_marche_selon_tolede': 'Market product according to Tolede',
      'sera_affiche_produit_marche': 'Will be displayed as market product'
    }
  },
  'mes_droits': {
    'title': 'My Rights',
    'error_loading': 'Error loading rights',
    'no_data': 'No data available',
    'synako_user_info': 'You are viewing the rights of the currently selected sales representative',
    'user_info': 'User information',
    'code_utilisateur': 'User code',
    'nom_prenom': 'Name',
    'email': 'Email',
    'not_specified': 'Not specified',
    'permissions': 'Permissions',
    'dero_autorisee': 'Line-by-line waiver injection (order)',
    'devis_en_tarif_autorise': 'Waiver validation (quote)',
    'prix_plancher_autorise': 'Below floor price',
    'access_scope': 'Access scope',
    'societes_autorisees': 'Authorized commercial companies',
    'all_societies': 'All companies',
    'client_autorises': 'Authorized clients',
    'all_clients': 'All clients',
    'refresh_button': 'Refresh my rights',
    'refresh_success': 'Rights successfully refreshed',
    'refresh_error': 'Error refreshing rights'
  },
  'mes_droits_synako': {
    'title': 'Sales Representative Selection',
    'error_loading': 'Error loading sales representatives list',
    'info_message': 'Select the France Frais sales representative you want to impersonate',
    'change_success': 'Sales representative selected successfully',
    'filters': 'Filters',
    'search': 'Search',
    'search_placeholder': 'Search by name, email or code...',
    'filter_societe': 'Commercial company',
    'all_societies': 'All companies',
    'filter_dero': 'Line-by-line waiver injection (order)',
    'filter_devis_tarif': 'Waiver validation (quote)',
    'filter_prix_plancher': 'Floor price',
    'list_title': 'Available sales representatives',
    'no_results': 'No sales representative found with these criteria',
    'table': {
      'code': 'Code',
      'nom': 'Name',
      'email': 'Email',
      'societes': 'Companies',
      'clients': 'Clients',
      'dero': 'Waiver',
      'devis_tarif': 'Quote/Rate',
      'prix_plancher': 'Floor price',
      'action': 'Action'
    },
    'all': 'All',
    'select': 'Select'
  },
  'branding': {
    'annonce_nouvelle_identite': {
      'titre': 'France Frais has a new look!',
      'texte': 'We are getting a fresh new identity.'
    },
    'slogan': 'A federation of distributors <br />owned by farmers.'
  },
  'file_size': {
    'zero_bytes': '0 Bytes',
    'bytes': 'Bytes',
    'kb': 'KB',
    'mb': 'MB',
    'gb': 'GB'
  },
  'client': {
    'conversations': {
      'titre': 'Conversations',
      'sous_titre': 'Our telesales and your sales rep are here to help',
      'sous_titre_commercial': 'with {{raison_sociale}}',
      'equipe_aide': 'Our team is here to help you',
      'commencer_conversation': 'Start a conversation',
      'appeler': 'Call {{nom}}',
      'bouton_appeler': 'Call',
      'reduire_chatbox': 'Minimize this chatbox',
      'onglet_en_cours': 'My conversations',
      'onglet_toutes': 'All conversations',
      'onglet_terminees': 'Ended conversations',
      'aucune_conversation': 'No conversations',
      'aucune_discussion_cloturee': 'No closed conversations',
      'titre_defaut': 'Conversation',
      'modifier_titre': 'Edit title',
      'hier': 'Yesterday',
      'aucun_message': 'No messages in this conversation.',
      'conversation_terminee': 'This conversation has been closed. You can reopen it by sending a message.',
      'conversation_cloturee_info': 'This conversation is closed, you will find it in your closed discussions. You can reopen it by sending a message.',
      'terminer_conversation': 'The answer suits me, close the conversation.',
      'placeholder_message': 'Type your message',
      'envoyer': 'Send',
      'ajouter_piece_jointe': 'Add document',
      'ajouter_image': 'Add image',
      'taille_fichier_ko': '{{taille}} KB',
      'format_non_supporte': 'File format "{{nom}}" is not supported (accepted formats: JPEG, PNG, GIF, WebP, PDF, Word, Excel)',
      'enregistrer_image': 'Save',
      'enregistrement_en_cours': 'Saving...',
      'image_enregistree': 'Image saved to gallery',
      'image_enregistree_court': 'Saved!',
      'erreur_enregistrement_image': 'Error saving image',
      'erreur_enregistrement_court': 'Error',
      'permission_galerie_refusee': 'Gallery access permission denied',
      'taille_inconnue': 'Unable to verify the size of file "{{nom}}"',
      'nouvelle': {
        'titre': 'New conversation',
        'retour': 'Back',
        'message_accueil': 'Hello,\nTo better respond to your request, please indicate the reason for your message.',
        'france_frais_connect': 'France Frais Connect',
        'raison_commande': 'Order',
        'raison_compte_client': 'Customer account',
        'raison_livraison': 'Delivery',
        'raison_autres': 'Other',
        'placeholder_message': 'Type your message',
        'envoyer': 'Send',
        'titre_conversation_date': 'Conversation of {{date}}'
      }
    },
    'mes_produits': {
      'ub_essentielles': {
        'titre': 'Essential UBs',
        'aucun_profil': 'No essential UB for this client.',
        'aucun_item_filtre': 'No UB matches this filter.',
        'voir_tous_les_produits': 'View all products of the UB',
        'filtres': {
          'tout': 'All',
          'actives': 'Active',
          'actives_one': 'Active',
          'actives_other': 'Active',
          'actives_many': 'Active',
          'actives_plural': 'Active',
          'perdu': 'Lost',
          'perdu_one': 'Lost',
          'perdu_other': 'Lost',
          'perdu_many': 'Lost',
          'perdu_plural': 'Lost',
          'en_baisse': 'Decreasing',
          'a_gagner': 'To win'
        },
        'section_statut': {
          'gagne': 'Active UB',
          'ras': 'Active UB',
          'perdu': 'Lost UB',
          'en-baisse': 'Declining UB',
          'a-gagner': 'UB to win'
        },
        'section_regle': {
          'gagne': '<strong>Active UB</strong>: the UB is active if at least one of its products has been ordered in the last 30 days.',
          'ras': '<strong>Active UB</strong>: the UB is active if at least one of its products has been ordered in the last 30 days.',
          'perdu': '<strong>Lost UB</strong>: the UB is lost if no product has been ordered in the last 30 days compared to the previous 30 days.',
          'en-baisse': '<strong>Declining UB</strong>: the UB is declining if the weight of ordered products has dropped by 30% in the last 30 days compared to the previous 30 days.',
          'a-gagner': '<strong>UB to win</strong>: the UB is to win if no product has been ordered in the last 60 days.'
        }
      }
    }
  },
  'marketplace': {
    'FF': 'Main catalog',
    'MATFER01': 'Matfer',
    'catalogue_MATFER01': 'Matfer catalog',
    'titre_catalogue': '{{nom}} catalog',
    'erreur_chargement_panier': 'Error loading cart'
  }
};
